
<template>
<div>
    <b-form>
        <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>

        <div class="box box-primary">
            <div class="box-header">
                <h3 class="box-title">{{$t('apartmentbookings.enter_customer_information')}}</h3>
            </div>
            <div class="box-body">
              <div style="border:0px solid red;background-color:#f7f7f7;display:flex;">

                <div style="border:0px solid blue;width:100%;">
                  <!--Left Contents-->
                  <div style="border:0px solid green;width:77%;" class="col-md-9">
                    <!--Booking Customer Information-->
                    <div style="border:2px solid #f29911;border-color:#f29911;background-color:white;margin:10px 10px 10px -5px;width:100%;" class="col-md-9">
                      <div class="row">
                        <div class="ribbon-22" style="width:140px;margin-bottom:20px;margin-top:20px;background-color:#f29911;color:white;font-weight:bold;">
                          <div style="padding:4px">{{$t('apartmentbookings.booking_customer_information')}}</div>
                        </div>
                        <!-- Booking code -->
                        <div class="row">
                          <div class="col-md-4" style="margin-left: 15px;">
                            <div class="form-group">
                              <label for="checkin">{{$t('apartmentbookings.booking_code')}}</label>
                              <input
                                disabled
                                v-model="apartment_bookings.booking_code"
                                type="text"
                                class="form-control"
                                :placeholder="$t('apartmentbookings.booking_code')"
                              >
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="checkin">{{$t('apartmentbookings.checkin_datetime')}}</label>
                            <date-picker :disabled="true" class="form-control" v-model="apartment_bookings.checkin_datetime" :config="options" ></date-picker>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="checkout">{{$t('apartmentbookings.checkout_datetime')}}</label>
                            <date-picker :disabled="true" class="form-control" :value="apartment_bookings.checkout_datetime"  v-model="apartment_bookings.checkout_datetime" :config="options" ></date-picker>
                          </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group warning">
                                <label for="number_of_days" class="control-label" :title="$t('apartmentbookings.number_of_days')">{{$t('apartmentbookings.number_of_days')}}</label>
                                <b-form-input :disabled="true" :value="get_number_of_days" type="number" :required="ischeck" class="form-control" id="number_of_days" :placeholder="$t('apartmentbookings.number_of_days')" />
                            </div>
                        </div>
                      </div>
                      <!--Booking Person Information-->
                      <div class="row">
                        <div class="col-md-4">
                              <div class="form-group required">
                                  <label for="first_name" class="control-label">{{$t('customer.firstname')}}</label>
                                  <input
                                    :disabled="disablecustomerform"
                                    v-model="apartment_bookings.booking_person_name"
                                    type="text"
                                    class="form-control"
                                    id="booking_person_name"
                                    :placeholder="$t('customer.firstname')"
                                    @input="validateFieldIsEmpty('booking_person_name', 'this.apartment_bookings.')"
                                  >
                                  <span v-if="this.field_required.booking_person_name != ''" class="help is-danger">
                                      <font color="red">{{ $t(field_required.booking_person_name) }}</font>
                                  </span>
                              </div>
                          </div>
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label for="email" class="control-label">{{$t('customer.email')}}</label>
                            <input
                                :disabled="disablecustomerform"
                                v-model="apartment_bookings.booking_person_email"
                                type="email"
                                class="form-control"
                                id="email"
                                placeholder="example@example.com"
                                @input="validateFieldIsEmpty('booking_person_email','this.apartment_bookings.')"
                            >

                            <span v-if="this.field_required.booking_person_email != ''" class="help is-danger">
                                <font color="red">{{ $t(field_required.booking_person_email) }}</font>
                            </span>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label for="phone" class="control-label">{{$t('customer.phone')}}</label>
                            <input
                              :disabled="disablecustomerform"
                              v-model="apartment_bookings.booking_person_phone"
                              type="text"
                              class="form-control"
                              id="phone"
                              :placeholder="$t('customer.phone')"
                              @input="validateFieldIsEmpty('booking_person_phone','this.apartment_bookings.')"
                            >
                            <span v-if="this.field_required.phone != ''" class="help is-danger">
                                <font color="red">{{ $t(field_required.booking_person_phone) }}</font>
                            </span>
                          </div>
                        </div>
                      </div>
                      <!-- GHI NHẬN THÔNG TIN XUẤT HOÁ ĐƠN -->
                      <div class="row">
                          <div class="col-md-12">
                              <div class="inside-section-header">
                                  <i data-v-2e17af2d="" class="fa fa-user"></i>
                                  <label>{{$t(`customer.info_invoice.title`)}}:</label>
                              </div>
                              <div class="row">
                                  <div class="col-md-3">
                                      <div class="form-group">
                                          <label for="cromcode">{{$t('customer.info_invoice.profile_company_name')}}</label>
                                          <input
                                              v-model="apartment_bookings.company_name"
                                              type="text"
                                              class="form-control"
                                              id="profile_company_name"
                                              :placeholder="$t('customer.info_invoice.profile_company_name')"
                                          >
                                      </div>
                                  </div>
                                  <div class="col-md-3">
                                      <div class="form-group">
                                          <label for="cromcode">{{$t('customer.info_invoice.profile_company_address')}}</label>
                                          <input
                                              v-model="apartment_bookings.company_address"
                                              type="text"
                                              class="form-control"
                                              id="profile_company_address"
                                              :placeholder="$t('customer.info_invoice.profile_company_address')"
                                          >
                                      </div>
                                  </div>
                                  <div class="col-md-3">
                                      <div class="form-group">
                                          <label for="cromcode">{{$t('customer.info_invoice.profile_company_tax_code')}}</label>
                                          <input
                                              v-model="apartment_bookings.company_tax_code"
                                              type="text"
                                              class="form-control"
                                              id="profile_company_tax_code"
                                              :placeholder="$t('customer.info_invoice.profile_company_tax_code')"
                                          >
                                      </div>
                                  </div>
                                  <div class="col-md-3">
                                      <div class="form-group">
                                          <label for="cromcode">{{$t('customer.info_invoice.profile_company_email')}}</label>
                                          <input
                                              v-model="apartment_bookings.company_email"
                                              type="email"
                                              class="form-control"
                                              id="profile_company_email"
                                              :placeholder="$t('customer.info_invoice.profile_company_email')"
                                          >
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                              <div class="form-group required">
                                  <label for="first_name">{{$t('customer.company')}}</label>
                                  <b-form-select :disabled="disablecustomerform"
                                      :options="leaseback_company_list"
                                      v-model="apartment_bookings.booking_company"
                                      class="form-control"
                                      @change="onChangeCompany"
                                  />
                              </div>
                          </div>
                          <div class="col-md-4">
                            <button
                                type="button"
                                class="btn btn-labeled btn-primary"
                                @click="showModalAddCompany"
                                style="margin-right: 5px;background-color: #f29911;border-color: #f29911;margin-top:25px;"
                            >
                                <span class="btn-label">
                                <i class="fa fa-plus"></i>
                                </span>
                                {{$t('customer.company')}}
                            </button>
                          </div>
                      </div>
                      <div class="row">
                          <div class="col-md-12">
                              <div class="form-group">
                                  <label for="country">{{$t('common.note')}}</label>
                                  <textarea class="form-control" rows="5" v-model="apartment_bookings.other_booking_details" :placeholder="$t('common.note') + '...'"></textarea>
                              </div>
                          </div>
                      </div>
                    </div>
                    <!--Booking Price Information-->
                    <div style="border:2px solid #f29911;border-color:#f29911;background-color:white;margin:10px 10px 10px -5px;width:100%;" class="col-md-9">
                      <div class="row">
                        <div class="ribbon-22" style="width:110px;margin-bottom:20px;margin-top:20px;background-color:#f29911;color:white;font-weight:bold;">
                          <div style="padding:4px">{{$t('apartmentbookings.booking_price_information.title')}}</div>
                        </div>
                      </div>
                      <div class="row">
                        <!-- Giarm giá -->
                        <div class="col-md-6">
                          <div class="form-group required">
                            <label for="package_sale_off">{{$t('apartmentbookings.booking_price_information.package_sale_off')}}</label>
                            <input
                              @change="calculatorAmount(apartmentBookedList)"
                              v-on:keyup="calculatorAmount(apartmentBookedList)"
                              v-model="apartment_bookings.sale_off"
                              type="text"
                              class="form-control"
                              id="package_sale_off"
                              :placeholder="$t('apartmentbookings.booking_price_information.package_sale_off')"
                            >
                          </div>
                        </div>
                        <!-- Khuyến mãi -->
                        <div class="col-md-6">
                          <div class="form-group required">
                            <label for="package_promotion">{{$t('apartmentbookings.booking_price_information.package_promotion')}}</label>
                            <input
                              @change="calculatorAmount(apartmentBookedList)"
                              v-on:keyup="calculatorAmount(apartmentBookedList)"
                              v-model="apartment_bookings.discount"
                              type="text"
                              class="form-control"
                              id="discount"
                              :placeholder="$t('apartmentbookings.booking_price_information.package_promotion')"
                            >
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                            <div class="form-group required">
                              <label for="phone">{{$t('apartmentbookings.status.payment_in_advance')}}</label>
                              <a 
                                v-on:click='onClickShowInvoiceGeneralInvoicePaymentInAdvance'
                                v-if="booking_id !== 0" 
                              >
                                <span class="btn-label" 
                                  :title="$t('apartmentbookings.booking_price_information.print_accept_invoice_general_invoice')">
                                  <i class="fa fa-plus"></i>
                                </span>
                              </a>
                              <input
                                :disabled="true"
                                @change="formatPaymentInAdvance"
                                v-on:keyup="formatPaymentInAdvance"
                                v-model="apartment_bookings.payment_in_advance"
                                type="text"
                                class="form-control"
                                id="payment_in_advance"
                                :readonly="true"
                                :placeholder="$t('apartmentbookings.status.payment_in_advance')"
                              >
                            </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group required">
                            <label for="email">{{$t('apartmentbookings.status.deposit')}}
                            </label>
                            <a 
                              v-on:click='onClickShowInvoiceGeneralInvoiceDeposit'
                              v-if="booking_id !== 0"
                            >
                              <span class="btn-label" 
                                :title="$t('apartmentbookings.booking_price_information.print_accept_invoice_general_invoice')">
                                <i class="fa fa-plus"></i>
                              </span>
                            </a>
                            <input
                                :disabled="true"
                                v-model="apartment_bookings.deposit"
                                @change="formatDeposit"
                                v-on:keyup="formatDeposit"
                                type="text"
                                class="form-control"
                                id="deposit"
                                :readonly="true"
                                :placeholder="$t('apartmentbookings.status.deposit')"
                            >
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>{{$t('apartmentbookings.booking_price_information.deposit_request')}}: </label>
                            <input
                              v-model="apartment_bookings.payment_inadvance_request"
                              type="text"
                              class="form-control"
                              id="deposit_request"
                              @change="onChangeDepositRequestOrPaymentInadvanceRequest"
                              v-on:keyup="onChangeDepositRequestOrPaymentInadvanceRequest"
                              :placeholder="$t('apartmentbookings.booking_price_information.deposit_request')"
                            >
                            <!-- {{apartment_bookings.total_booking_room_rate_after_vat}} -->
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>{{$t('apartmentbookings.booking_price_information.payment_inadvance_request')}}: </label>
                            <input
                              v-model="apartment_bookings.deposit_request"
                              type="text"
                              class="form-control"
                              id="payment_inadvance_request"
                              @change="onChangeDepositRequestOrPaymentInadvanceRequest"
                              v-on:keyup="onChangeDepositRequestOrPaymentInadvanceRequest"
                              :placeholder="$t('apartmentbookings.booking_price_information.payment_inadvance_request')"
                            >
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label>{{$t('apartmentbookings.deposit_deadline')}}</label>
                            <date-picker
                              @dp-change="onChangeDepositDate"
                              v-model="apartment_bookings.deposit_deadline"
                              :config="options"
                            ></date-picker>
                          </div>
                        </div>
                        <div class="col-md-4 ">
                          <div class="form-group required">
                            <label for="package_summary">{{$t('apartmentbookings.booking_price_information.summary')}}</label>
                            <input
                              v-model="apartment_bookings.package_summary"
                              type="text"
                              class="form-control"
                              id="package_summary"
                              readonly
                              :placeholder="$t('apartmentbookings.booking_price_information.summary')"
                            >
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label>{{$t('apartmentbookings.tax')}}</label>
                            <input
                              disabled
                              v-model="apartment_bookings.booking_room_rate_after_vat"
                              type="text"
                              class="form-control"
                              :placeholder="'Thuế'"
                            >
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label style="color: blue;">* {{$t('apartmentbookings.summary_after_vat')}}</label>
                            <input
                              disabled
                              v-model="apartment_bookings.total_booking_room_rate_after_vat"
                              type="text"
                              class="form-control"
                              readonly
                              :placeholder="'Tổng Tiền Sau Thuê '"
                            >
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label style="color: blue;">* Tổng Tiền Sau Khuyến Mãi</label>
                            <input
                              disabled
                              v-model="apartment_bookings.total_booking_room_rate_after_promotion"
                              type="text"
                              class="form-control"
                              readonly
                              :placeholder="'Tổng Tiền Sau Khuyến Mãi'"
                            >
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group required">
                            <label style="color: blue;">* {{$t('apartmentbookings.booking_price_information.total_amount_request')}}</label>
                            <input
                              disabled
                              v-model="apartment_bookings.total_deposit"
                              type="text"
                              class="form-control"
                              readonly
                              :placeholder="'Tổng Tiền Giữ Chỗ'"
                            >
                          </div>
                        </div>
                      </div>
                      <!--Booking Price Information-->
                    </div>
                    <div style="border:2px solid #f29911;border-color:#f29911;background-color:white;margin:10px 10px 10px -5px;width:100%;" class="col-md-9">
                      <div class="row">
                        <div class="ribbon-22" style="width:162px;margin-bottom:20px;margin-top:20px;background-color:#f29911;color:white;font-weight:bold;">
                          <div style="padding:4px">{{$t('apartmentbookings.apartment_leaseback_clients.title')}}</div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <label for="cmnd_passport" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.cmnd_passport')}}</label>
                            <input
                              :disabled="disablecustomerform"
                              v-model="apartment_leaseback_clients.id_passsport"
                              type="text"
                              class="form-control"
                              id="cmnd_passport"
                              :placeholder="$t('apartmentbookings.apartment_leaseback_clients.cmnd_passport')"
                            >
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                              <label for="cmnd_passport_date" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.cmnd_passport_date')}}</label>
                              <date-picker :placeholder="$t('apartmentbookings.apartment_leaseback_clients.cmnd_passport_date')" class="form-control" v-model="apartment_leaseback_clients.id_passsport_issued_date" :config="options" id="cmnd_passport_date"></date-picker>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group">
                            <button
                              type="button"
                              class="btn btn-labeled btn-primary"
                              @click="clickEventOpenModalLeasebackClients"
                              style="margin-right: 5px;background-color: #f29911;border-color: #f29911;margin-top:25px;"
                            >
                              <span class="btn-label">
                              <i class="fa fa-users"></i>
                              </span>
                              {{$t('apartmentbookings.apartment_leaseback_clients.client')}}
                            </button>
                          </div>
                        </div>

                        <div class="col-md-4">
                            <div class="form-group required">
                                <label for="full_name" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.fullname')}}</label>
                                <input
                                  :disabled="disablecustomerform"
                                  v-model="apartment_leaseback_clients.full_name"
                                  type="text"
                                  class="form-control"
                                  id="full_name"
                                  :placeholder="$t('apartmentbookings.apartment_leaseback_clients.fullname')"

                                >
                            </div>
                        </div>

                        <div class="col-md-4">
                          <div class="form-group">
                              <label for="dob" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.dob')}}</label>
                              <date-picker :placeholder="$t('apartmentbookings.apartment_leaseback_clients.dob')" class="form-control" v-model="apartment_leaseback_clients.dob" :config="options" id="dob"></date-picker>
                          </div>
                        </div>


                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="address" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.address')}}</label>
                                <input
                                  :disabled="disablecustomerform"
                                  v-model="apartment_leaseback_clients.address"
                                  type="text"
                                  class="form-control"
                                  id="address"
                                  :placeholder="$t('apartmentbookings.apartment_leaseback_clients.address')"

                                >
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="email" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.email')}}</label>
                                <input
                                  :disabled="disablecustomerform"
                                  v-model="apartment_leaseback_clients.email"
                                  type="email"
                                  class="form-control"
                                  id="email"
                                  :placeholder="$t('apartmentbookings.apartment_leaseback_clients.email')"

                                >
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="phone" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.phone')}}</label>
                                <input
                                  :disabled="disablecustomerform"
                                  v-model="apartment_leaseback_clients.phone"
                                  type="text"
                                  class="form-control"
                                  id="phone"
                                  :placeholder="$t('apartmentbookings.apartment_leaseback_clients.phone')"

                                >
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="gender" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.gender')}}</label>
                                <select :disabled="disablecustomerform" v-model="apartment_leaseback_clients.gender" class="form-control">
                                    <option
                                        v-for="gender in gender_list"
                                        v-bind:value="gender.id"
                                        :key="gender.id"
                                    >{{ $t(gender.text) }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="country_code">{{$t('apartmentbookings.apartment_leaseback_clients.country')}}</label>
                                <b-form-select :disabled="disablecustomerform"
                                    :options="country_list"
                                    v-model="apartment_leaseback_clients.country_code"
                                    class="form-control"
                                />
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Ngày Giờ Check-in</label>
                                <date-picker :placeholder="$t('apartment.reservations.date_checkin')" class="form-control" v-model="apartment_leaseback_clients.checkin_datetime" :config="dateTimeOptions" id="visa_expired_date"></date-picker>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Ngày Giờ Check-out</label>
                                <date-picker :placeholder="$t('apartment.reservations.date_checkout')" class="form-control" v-model="apartment_leaseback_clients.checkout_datetime" :config="dateTimeOptions"></date-picker>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t('apartmentbookings.apartment_leaseback_clients.visa_number')}}</label>
                                <input
                                  v-model="apartment_leaseback_clients.visa_number"
                                  type="text"
                                  class="form-control"
                                  :placeholder="$t('apartmentbookings.apartment_leaseback_clients.visa_number')"
                                >
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t('apartmentbookings.apartment_leaseback_clients.visa_expired_date')}}</label>
                                <date-picker :placeholder="$t('apartmentbookings.apartment_leaseback_clients.visa_expired_date')" class="form-control" v-model="apartment_leaseback_clients.visa_expired_date" :config="options" id="visa_expired_date"></date-picker>
                            </div>
                        </div>
                        <div class="col-md-4" v-if="false">
                            <div class="form-group">
                                <label>{{$t('apartmentbookings.apartment_leaseback_clients.vn_tmp_stay_start')}}</label>
                                <date-picker :placeholder="$t('apartmentbookings.apartment_leaseback_clients.vn_tmp_stay_start')" class="form-control" v-model="apartment_leaseback_clients.vn_tmp_stay_start" :config="options"></date-picker>
                            </div>
                        </div>
                        <div class="col-md-4" v-if="false">
                            <div class="form-group">
                                <label>{{$t('apartmentbookings.apartment_leaseback_clients.vn_tmp_stay_end')}}</label>
                                <date-picker :placeholder="$t('apartmentbookings.apartment_leaseback_clients.vn_tmp_stay_end')" class="form-control" v-model="apartment_leaseback_clients.vn_tmp_stay_end" :config="options"></date-picker>
                            </div>
                        </div>
                        <div class="col-md-4" v-if="false">
                            <div class="form-group">
                                <label>{{$t('apartmentbookings.apartment_leaseback_clients.represent')}}</label>
                                <input
                                  v-model="apartment_leaseback_clients.represent"
                                  type="text"
                                  class="form-control"
                                  :placeholder="$t('apartmentbookings.apartment_leaseback_clients.represent')"
                                >
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>{{$t('apartmentbookings.apartment_leaseback_clients.flight')}}</label>
                                <input
                                  v-model="apartment_leaseback_clients.flight"
                                  type="text"
                                  class="form-control"
                                  :placeholder="$t('apartmentbookings.apartment_leaseback_clients.flight')"
                                >
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="other_details" class="control-label">{{$t('apartmentbookings.apartment_leaseback_clients.other_details')}}</label>
                                <textarea
                                  :disabled="disablecustomerform"
                                  v-model="apartment_leaseback_clients.other_details"
                                  class="form-control"
                                  id="other_details"
                                  :placeholder="$t('apartmentbookings.apartment_leaseback_clients.other_details')"
                                  rows="5"
                                >
                                </textarea>
                            </div>
                        </div>
                      </div>
                      <div class="row">
                        <button
                          type="button"
                          class="btn btn-labeled btn-info pull-right"
                          style="margin-right: 5px;"
                          @click="onResetApartmentLeasebackClients"
                        >
                          <span class="btn-label">
                            <i class="glyphicon glyphicon-repeat"></i>
                          </span>
                          {{$t('apartmentbookings.apartment_leaseback_clients.reset')}}
                        </button>
                        <button
                          type="button"
                          class="btn btn-labeled btn-info pull-right"
                          style="margin-right: 5px;"
                          @click="onSaveApartmentLeasebackClients"
                        >
                          <span class="btn-label">
                            <i class="glyphicon glyphicon-edit"></i>
                          </span>
                          {{$t('apartmentbookings.apartment_leaseback_clients.save')}}
                        </button>
                      </div>

                    <hr/>
                    <h4 style="text-align:center; color: blue;">{{$t('apartmentbookings.apartment_leaseback_clients.registered_clients')}}</h4>
                    <!-- Leaseback apartment client list-->
                    <div>
                      <table id="dtHorizontal" class="table-bordered table-striped mb-0">
                        <thead>
                          <th>STT</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.main_contact')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.fullname')}}</th>
                          <th>{{$t('apartmentbookings.checkin_datetime')}}</th>
                          <th>{{$t('apartmentbookings.checkout_datetime')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.cmnd_passport')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.cmnd_passport_date')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.address')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.email')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.phone')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.dob')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.gender')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.country')}}</th>
                          <th v-if="false">{{$t('apartmentbookings.apartment_leaseback_clients.represent')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.visa_number')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.visa_expired_date')}}</th>
                          <th v-if="false">{{$t('apartmentbookings.apartment_leaseback_clients.vn_tmp_stay_start')}}</th>
                          <th v-if="false">{{$t('apartmentbookings.apartment_leaseback_clients.vn_tmp_stay_end')}}</th>
                          <th>{{$t('apartmentbookings.apartment_leaseback_clients.flight')}}</th>
                          <th>{{$t('common.action')}}</th>
                        </thead>
                        <tbody>
                          <tr v-for="(items, index) in list_apartment_lease_back_clients_selected" :key="index">
                            <td class="col-sm-1 col-md-1 col-lg-1">
                              {{index + 1}}
                            </td>
                            <td style="text-align: center;vertical-align: middle;" class="col-sm-1 col-md-1 col-lg-1">
                              <div class="btn-group">
                                <input :checked="items.selected" type="radio" name="mainContact" class="btn btn-sm btn-info" @click="selectMainContact(items)">
                              </div>
                            </td>
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.full_name}}
                              </div>
                              <div v-else>
                                <input type="text" v-model="items.full_name" class="resize-width"/>
                              </div>
                            </td>
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{formatDateTimeWithHour(items.checkin_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm') != 'Invalid date' ? formatDateTimeWithHour(items.checkin_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm') : null}}
                              </div>
                              <div v-else>
                                <input type="text" v-model="items.full_name" class="resize-width"/>
                              </div>
                            </td>
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{formatDateTimeWithHour(items.checkout_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm') != 'Invalid date' ? formatDateTimeWithHour(items.checkout_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm') : null}}
                              </div>
                              <div v-else>
                                <input type="text" v-model="items.full_name" class="resize-width"/>
                              </div>
                            </td>
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.id_passsport}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.id_passsport" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Passport date -->
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{formatDateTime(items.id_passsport_issued_date, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') != 'Invalid date' ? formatDateTime(items.id_passsport_issued_date, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') : null}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.id_passsport_issued_date" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Address -->
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.address}}
                              </div>
                              <div v-else>
                                <input type="text" v-model="items.address" class="resize-width"/>
                              </div>
                            </td>
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.email}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.email" class="resize-width"/>
                              </div>
                            </td>
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.phone}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.phone" class="resize-width"/>
                              </div>
                            </td>
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{formatDateTime(items.dob, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') != 'Invalid date' ? formatDateTime(items.dob, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') : null}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.dob" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Gender -->
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.gender == 1 ? $t('customer.gender_type[0]') : (items.gender == 2 ? $t('customer.gender_type[1]') : $t('customer.gender_type[2]'))}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.gender" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Country -->
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{getCountryName(items.country)}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.country" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Represent -->
                            <td class="col-sm-2 col-md-2 col-lg-2" v-if="false">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.represent}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.represent" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Visa Number -->
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.visa_number}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.visa_number" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Visa Expired Date -->
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{formatDateTime(items.visa_expired_date, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') != 'Invalid date' ? formatDateTime(items.visa_expired_date, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') : null}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.visa_expired_date" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Vn Tmp Stay Start -->
                            <td class="col-sm-2 col-md-2 col-lg-2" v-if="false">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{formatDateTime(items.vn_tmp_stay_start, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') != 'Invalid date' ? formatDateTime(items.vn_tmp_stay_start, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') : null}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.vn_tmp_stay_start" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Vn Tmp Stay End -->
                            <td class="col-sm-2 col-md-2 col-lg-2" v-if="false">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{formatDateTime(items.vn_tmp_stay_end, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') != 'Invalid date' ? formatDateTime(items.vn_tmp_stay_end, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY') : null}}
                              </div>
                              <div v-else>
                                <input type="number" v-model="items.vn_tmp_stay_end" class="resize-width"/>
                              </div>
                            </td>
                            <!-- Flight -->
                            <td class="col-sm-2 col-md-2 col-lg-2">
                              <div v-if="items!==selectedItemLeaseBackClient">
                                {{items.flight}}
                              </div>
                              <div v-else>
                                <input type="text" v-model="items.flight" class="resize-width"/>
                              </div>
                            </td>
                            <td class="col-sm-1 col-md-1 col-lg-1">
                              <div class="btn-group">
                                <button type="button" class="btn btn-sm btn-info" @click="onEditApartmentLeaseBackClient(items)">
                                  <i class="fa fa-edit"></i>
                                </button>
                              </div>
                              <div class="btn-group">
                                <button type="button" class="btn btn-sm btn-warning"  @click="onDeleteApartmentLeaseBackClient(items)">
                                  <i class="fa fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <span v-if="list_apartment_lease_back_clients_selected.length === 0" style="color:red;"><i>{{$t('apartmentbookings.apartment_leaseback_clients.no_registered_clients')}}</i></span>
                    </div>
                    </div>
                    <!-- Apartment bedroom register -->
                    <div style="border:2px solid #f29911;border-color:#f29911;background-color:white;margin:10px 10px 10px -5px;width:100%;" class="col-md-9">
                        <div class="row">
                            <div class="ribbon-22" style="width:200px;margin-bottom:20px;margin-top:20px;background-color:#f29911;color:white;font-weight:bold;">
                                <div style="padding:4px">Danh Sách Phòng Đăng Ký</div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <b-table style="white-space: nowrap;" :busy="isLoadingApartmentBookedList" responsive :items="apartmentBookedList" :fields="apartmentAvailableBookedFields" class="mt-3" outlined>
                                <template v-slot:table-busy>
                                  <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>{{$t('reportLiabilitiesReport.loading')}}</strong>
                                  </div>
                                </template>
                                <template #head()="scope">
                                  <div>{{ $t(scope.label) }}</div>
                                </template>
                                <template slot="pkg_template" slot-scope="row">
                                  <template>
                                    <div v-if="row.item.apartment_room_type == '1 PN'" style="width: 250px;">
                                      <div class="col-md-12">
                                        <!-- Select option package -->
                                        <leaseback-select-option-package
                                          @package-onemonth-elements="onPackageOneMonthObject"
                                          @package-current-elements="onPackageCurrent"
                                          @clickOnItem="onChangeSelect"
                                          :packageId="row.item.pkg_template"
                                          :apartmentId="row.item.apartment"
                                          :isOnlyShowInputPackage="true"
                                          :bedroomCount="1"
                                          :row="row.item"
                                        />
                                      </div>
                                    </div>
                                    <div v-else-if="row.item.apartment_room_type == '2 PN'" style="width: 250px;">
                                      <div class="col-md-12">
                                        <!-- Select option package -->
                                        <leaseback-select-option-package
                                          @package-onemonth-elements="onPackageOneMonthObject"
                                          @package-current-elements="onPackageCurrent"
                                          @clickOnItem="onChangeSelect"
                                          :packageId="row.item.pkg_template"
                                          :apartmentId="row.item.apartment"
                                          :isOnlyShowInputPackage="true"
                                          :bedroomCount="2"
                                          :row="row.item"
                                        />
                                      </div>
                                    </div>
                                    <div v-else-if="row.item.apartment_room_type == '3 PN'" style="width: 250px;">
                                      <div class="col-md-12">
                                        <!-- Select option package -->
                                        <leaseback-select-option-package
                                          @package-onemonth-elements="onPackageOneMonthObject"
                                          @package-current-elements="onPackageCurrent"
                                          @clickOnItem="onChangeSelect"
                                          :packageId="row.item.pkg_template"
                                          :apartmentId="row.item.apartment"
                                          :isOnlyShowInputPackage="true"
                                          :bedroomCount="3"
                                          :row="row.item"
                                        />
                                      </div>
                                    </div>
                                  </template>
                                </template>
                                <!-- Electric, Water included -->
                                <template slot="ew_included" slot-scope="row">
                                  <template>
                                    <div>
                                      <input type="checkbox" v-model="row.item.ew_included">
                                    </div>
                                  </template>
                                </template>
                                <!-- Start Electric -->
                                <template slot="start_e" slot-scope="row">
                                  <template>
                                    <div>
                                      <input min="0" style="width: 50px;" placeholder="Chỉ Số Điện Gốc" type="number" v-model="row.item.start_e">
                                    </div>
                                  </template>
                                </template>
                                <!-- Start Water -->
                                <template slot="start_w" slot-scope="row">
                                  <template>
                                    <div>
                                      <input min="0" style="width: 50px;" placeholder="Chỉ Số Nước Gốc" type="number" v-model="row.item.start_w">
                                    </div>
                                  </template>
                                </template>
                                <!-- Payment duration factor -->
                                <template slot="payment_duration_factor" slot-scope="row">
                                  <template>
                                    <div>
                                      <b-form-select
                                        :options="paymentDurationFactor"
                                        v-model="row.item.payment_duration_factor"
                                        class="form-control"
                                        disabled
                                      />
                                    </div>
                                  </template>
                                </template>
                                <!-- Other fee -->
                                <template slot="other_fee" slot-scope="row">
                                  <template>
                                    <div>
                                      <input @change="formatOtherFee(row)" v-on:keyup="formatOtherFee(row)" min="0" style="width: 120px;" placeholder="Chi Phí Khác" type="text" v-model="row.item.other_fee">
                                    </div>
                                  </template>
                                </template>
                                <!-- Other vat -->
                                <template slot="other_vat" slot-scope="row">
                                  <template>
                                    <div>
                                      <input min="0" max="100" style="width: 50px;" placeholder="Thuế" type="number" v-model="row.item.other_vat">
                                    </div>
                                  </template>
                                </template>
                                <!-- Other details -->
                                <template slot="other_details" slot-scope="row">
                                  <template>
                                    <div>
                                      <input placeholder="Chí Tiết Khác" type="text" v-model="row.item.other_details">
                                    </div>
                                  </template>
                                </template>
                                <!-- Booking status code -->
                                <template slot="booking_status" slot-scope="row">
                                  <template>
                                    <div>
                                      <select disabled v-model="row.item.booking_status" class="form-control">
                                        <option
                                          v-for="status in bookingStatusCodes"
                                          v-bind:value="status.id"
                                          :key="status.id"
                                        >{{ $t(status.text) }}</option>
                                      </select>
                                      <!-- <input placeholder="Trạng Thái Đặt Phòng" type="text" v-model="row.item.booking_status"> -->
                                    </div>
                                  </template>
                                </template>
                            </b-table>
                        </div>
                    </div>
                  </div>
                  <!--Right Contents-->
                  <div class="col-md-3" style="width: 23% !important;top:0">
                      <div class="row right-element-container">
                        <div class="form-group">
                          <div class="ribbon-21" style="width:200px;margin-bottom:20px;margin-top:20px;background-color:#488BF8;color:white;font-weight:bold;">
                            <div style="padding:4px;">Số Lượng Phòng Khả Dụng</div>
                          </div>
                          <!-- Single room -->
                          <div>
                            <table id="dtHorizontal" class="table-bordered table-striped mb-0">
                              <thead>
                                <th>STT</th>
                                <th>Loại Phòng</th>
                                <th>Tổng</th>
                                <th>Đặt</th>
                                <th>Trống</th>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="col-sm-1 col-md-1 col-lg-1">
                                    {{singleApartmentData.stt}}
                                  </td>
                                  <td style="text-align: center;vertical-align: middle;" class="col-sm-1 col-md-1 col-lg-1">
                                    <div class="btn-group">
                                      {{singleApartmentData.room_type}}
                                    </div>
                                  </td>
                                  <!-- Total apartment -->
                                  <td class="col-sm-2 col-md-2 col-lg-2">
                                    <div>
                                      {{singleApartmentData.total_room}}
                                    </div>
                                  </td>
                                  <!-- Booking apartment -->
                                  <td class="col-sm-2 col-md-2 col-lg-2">
                                      <input @change="onChangeBookingRoom('single')" v-on:keyup="onChangeBookingRoom('single')" style="width: 50px;text-align: center" :min="0" :max="singleApartmentData.total_available_room" type="number" v-model="singleApartmentData.total_booking_room">
                                  </td>
                                  <!-- Total apartment available -->
                                  <td class="col-sm-2 col-md-2 col-lg-2">
                                    <div style="color: red;font-weight: bold;">
                                      {{singleApartmentData.total_available_room}}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <span v-if="apartmentSingleRoomAvailableBookingList.length === 0 && !isLoadingAvailableApartmentList" style="color:red;"><i>Không có phòng đơn</i></span>
                            <div style="max-height:200px; overflow:scroll; overflow-x:hidden;margin-top: 15px;">
                              <div v-if="isLoadingAvailableApartmentList">
                                <div class="text-center text-danger my-2">
                                  <b-spinner class="align-middle"></b-spinner>
                                  <strong>{{$t('reportLiabilitiesReport.loading')}}</strong>
                                </div>
                              </div>
                              <div v-else v-for="(item, index) in apartmentSingleRoomAvailableBookingList" :key="index" class="col-sm-4 col-md-4 col-lg-4">
                                <div class="row" style="cursor: pointer">
                                  <div @click="selectApartmentAvailable($event, item, index)" :class="item.is_checked && 'bg-select'" style="margin: 2px; padding: 4px 8px 4px 8px; text-align: center; border-radius: 5px;">{{item.apartment_code}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div style="clear:both;margin-top: 15px;"></div>
                          <!-- Couple room -->
                          <div>
                            <table id="dtHorizontal" class="table-bordered table-striped mb-0">
                              <thead>
                                <th>STT</th>
                                <th>Loại Phòng</th>
                                <th>Tổng</th>
                                <th>Đặt</th>
                                <th>Trống</th>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="col-sm-1 col-md-1 col-lg-1">
                                    {{coupleApartmentData.stt}}
                                  </td>
                                  <td style="text-align: center;vertical-align: middle;" class="col-sm-1 col-md-1 col-lg-1">
                                    <div class="btn-group">
                                      {{coupleApartmentData.room_type}}
                                    </div>
                                  </td>
                                  <!-- Total apartment -->
                                  <td class="col-sm-2 col-md-2 col-lg-2">
                                    <div>
                                      {{coupleApartmentData.total_room}}
                                    </div>
                                  </td>
                                  <!-- Booking apartment -->
                                  <td class="col-sm-2 col-md-2 col-lg-2">
                                    <div>
                                      <input @change="onChangeBookingRoom('couple')" v-on:keyup="onChangeBookingRoom('couple')" style="width: 50px;text-align: center" :min="0" :max="coupleApartmentData.total_available_room" type="number" v-model="coupleApartmentData.total_booking_room">
                                    </div>
                                  </td>
                                  <!-- Total apartment available -->
                                  <td class="col-sm-2 col-md-2 col-lg-2">
                                    <div>
                                      {{coupleApartmentData.total_available_room}}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <span v-if="apartmentCoupleRoomAvailableBookingList.length === 0 && !isLoadingAvailableApartmentList" style="color:red;"><i>Không có phòng đôi</i></span>
                            <div style="max-height:200px; overflow:scroll; overflow-x:hidden;margin-top: 15px;">
                              <div v-if="isLoadingAvailableApartmentList">
                                <div class="text-center text-danger my-2">
                                  <b-spinner class="align-middle"></b-spinner>
                                  <strong>{{$t('reportLiabilitiesReport.loading')}}</strong>
                                </div>
                              </div>
                              <div v-else v-for="(item, index) in apartmentCoupleRoomAvailableBookingList" :key="index" class="col-sm-4 col-md-4 col-lg-4">
                                <div class="row" style="cursor: pointer">
                                  <div @click="selectApartmentAvailable($event, item, index)" :class="item.is_checked && 'bg-select'" style="margin: 2px; padding: 4px 8px 4px 8px; text-align: center; border-radius: 5px;">{{item.apartment_code}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div style="clear:both;margin-top: 15px;"></div>
                          <!-- Triple room -->
                          <div>
                            <table id="dtHorizontal" class="table-bordered table-striped mb-0">
                              <thead>
                                <th>STT</th>
                                <th>Loại Phòng</th>
                                <th>Tổng</th>
                                <th>Đặt</th>
                                <th>Trống</th>
                              </thead>
                              <tbody>
                                <tr>
                                  <td class="col-sm-1 col-md-1 col-lg-1">
                                    {{tripleApartmentData.stt}}
                                  </td>
                                  <td style="text-align: center;vertical-align: middle;" class="col-sm-1 col-md-1 col-lg-1">
                                    <div class="btn-group">
                                      {{tripleApartmentData.room_type}}
                                    </div>
                                  </td>
                                  <!-- Total apartment -->
                                  <td class="col-sm-2 col-md-2 col-lg-2">
                                    <div>
                                      {{tripleApartmentData.total_room}}
                                    </div>
                                  </td>
                                  <!-- Booking apartment -->
                                  <td class="col-sm-2 col-md-2 col-lg-2">
                                    <div>
                                      <input @change="onChangeBookingRoom('triple')" v-on:keyup="onChangeBookingRoom('triple')" style="width: 50px;text-align: center" :min="0" :max="tripleApartmentData.total_available_room" type="number" v-model="tripleApartmentData.total_booking_room">
                                    </div>
                                  </td>
                                  <!-- Total apartment available -->
                                  <td class="col-sm-2 col-md-2 col-lg-2">
                                    <div>
                                      {{tripleApartmentData.total_available_room}}
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <span v-if="apartmentTripleRoomAvailableBookingList.length === 0 && !isLoadingAvailableApartmentList" style="color:red;"><i>Không có căn 3 phòng ngủ</i></span>
                            <div style="max-height:200px; overflow:scroll; overflow-x:hidden;margin-top: 15px;">
                              <div v-if="isLoadingAvailableApartmentList">
                                <div class="text-center text-danger my-2">
                                  <b-spinner class="align-middle"></b-spinner>
                                  <strong>{{$t('reportLiabilitiesReport.loading')}}</strong>
                                </div>
                              </div>
                              <div v-else v-for="(item, index) in apartmentTripleRoomAvailableBookingList" :key="index" class="col-sm-4 col-md-4 col-lg-4">
                                <div class="row" style="cursor: pointer">
                                  <div @click="selectApartmentAvailable($event, item, index)" :class="item.is_checked && 'bg-select'" style="margin: 2px; padding: 4px 8px 4px 8px; text-align: center; border-radius: 5px;">{{item.apartment_code}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
                  <!--Right Contents-->
                </div>
              </div>
            </div>
            <!-- /.box-body -->
            <div class="box-footer">
                <div class="col-md-9" style="border:0px solid red;">
                  <button
                      type="button"
                      class="btn btn-labeled btn-danger"
                      @click="CancelCustomerList"
                      style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
                  >
                      <span class="btn-label">
                      <i class="fa fa-mail-reply"></i>
                      </span>
                      {{$t('common.back')}}
                  </button>
                  <button
                    type="button"
                    class="btn btn-labeled btn-danger"
                    @click="sendEmailConfirmedBooking"
                    style="margin-right: 5px;background-color: #f29911;border-color: #f29911;"
                    v-if="booking_id !== 0"
                  >
                    <span class="btn-label">
                    <i class="fa fa-print"></i>
                    </span>
                    In Thư Xác Nhận Đặt Phòng
                  </button>
                  <button
                    v-if="booking_id === 0"
                    type="button"
                    :class="'btn btn-success btn-labeled pull-right'"
                    @click="!isLoadingApartmentBookedList && saveBooking(booking_status = BookingStatusEnum.CONFIRMED)"
                    :style="!isLoadingApartmentBookedList ? 'margin-right: 5px;' : 'margin-right: 5px;opacity: 0.5;'"
                  >
                      <span class="btn-label">
                      <i class="glyphicon glyphicon-ok"></i>
                      </span>
                      {{$t('common.confirm_booking')}}
                  </button>
                  <button
                      v-if="apartment_bookings.booking_status !== BookingStatusEnum.ONBOARD"
                      type="button"
                      class="btn-success btn btn-labeled pull-right"
                      @click="!isLoadingApartmentBookedList && saveBooking(booking_status = BookingStatusEnum.ONBOARD)"
                      :style="!isLoadingApartmentBookedList ? 'margin-right: 5px;' : 'margin-right: 5px;opacity: 0.5;'"
                  >
                      <span class="btn-label">
                      <i class="glyphicon glyphicon-copy"></i>
                      </span>
                      {{$t('common.checkin')}}
                  </button>
                  <div class="btn-group pull-right" v-if="booking_id !== 0">
                    <button :style="!isLoadingApartmentBookedList ? 'margin-right: 5px;' : 'margin-right: 5px;opacity: 0.5;'" type="button" class="btn btn-info" @click="!isLoadingApartmentBookedList && saveBooking()">
                      <i class="glyphicon glyphicon-edit"></i>
                      {{$t('common.edit_booking')}}
                    </button>
                  </div>
                  <button
                    v-if="booking_id !== 0 && apartment_bookings.booking_status != BookingStatusEnum.ONBOARD && apartment_bookings.booking_status != BookingStatusEnum.CHECKOUT"
                    type="button"
                    class="btn btn-labeled btn-warning pull-right"
                    @click="!isLoadingApartmentBookedList && saveBooking(booking_status = BookingStatusEnum.CANCELLED)"
                    :style="!isLoadingApartmentBookedList ? 'margin-right: 5px;' : 'margin-right: 5px;opacity: 0.5;'"
                >
                    <span class="btn-label">
                    <i class="glyphicon glyphicon-remove"></i>
                    </span>
                    {{$t('common.cancel_booking')}}
                </button>
                </div>
            </div>
            <b-button ref="formsubmitbutton" type="submit" variant="primary" style="display: none;">{{$t('common.submit')}}</b-button>
        </div>
    </b-form>
    <lte-modal-partment-leaseback-company
      ref="modalApartmentLeaseBackCompany"
      @reload_leaseback_company="reloadLeaseBackCompany"
    ></lte-modal-partment-leaseback-company>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <!-- Delete Confirm Modal Component -->
    <div class="modal fade" id="modal-apartment-leaseback-client-delete">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">{{$t('apartmentbookings.apartment_leaseback_clients.modal_apartment_leaseback_client.deletetitle')}}</h4>
          </div>
          <div class="modal-body">
            {{$t('apartmentbookings.apartment_leaseback_clients.modal_apartment_leaseback_client.deletemsg')}}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" style="background-color: #f29911;border-color: #f29911;color:#fff">{{$t('common.back')}}</button>
            <button type="button" class="btn btn-primary btn-green" @click="onConfirmDelete">{{$t('common.confirm')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- Modal Cancel Apartment Booking -->
    <div class="modal fade" id="modal-cancel-apartment-booking">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Xác Nhận Hủy Đặt Phòng</h4>
          </div>
          <div class="modal-body">
            <p>* {{$t('apartment.customer')}}: {{apartment_bookings.booking_person_name}}</p>
            <p>* {{$t('apartment.apartment_code')}}: <span v-for="(apartmentBooked, index) in apartmentBookedList" :key="index">{{apartmentBooked.apartment_code}}{{index != apartmentBookedList.length - 1 ? ', ' : ''}}</span></p>
            <p>* {{$t('apartmentbookings.booking_code')}}: {{apartment_bookings.booking_code}}</p>
            <p v-if="apartment_bookings.deposit != 0">- Tiền cọc: {{apartment_bookings.deposit}}</p>
            <p>* {{$t('apartmentbookings.reason')}}</p>
            <textarea class="form-control" rows="4" v-model="apartment_bookings.other_booking_details" :placeholder="$t('apartmentbookings.reason') + '...'"></textarea>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" style="background-color: #f29911;border-color: #f29911;color:#fff">{{$t('common.back')}}</button>
            <button type="button" class="btn btn-primary btn-green" @click="confirmCancelApartmentBooking">{{$t('common.confirm')}}</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <select-lease-back-clients-modal id="modal-select-client" :userId="1" @doSelectClient="doSelectClient" />
    <lte-modal-invoice-general-invoice-detail
      ref="modalInvoiceGeneralInvoiceDetail"
      @callbackInvoiceGeneralInvoiceSuccess="onInvoiceGeneralInvoiceSuccess"
      :type_booking="'group'"
    ></lte-modal-invoice-general-invoice-detail>
</div>
</template>

<script>
import LTECoreAlert from "@/components/LTESnackBar.vue";
import datePicker from "vue-bootstrap-datetimepicker";
import Loading from "vue-loading-overlay";
import {
    mapGetters,
    mapActions
} from "vuex";
import constantsData from '@/lib/constantsData';
import moment from "moment";
import utils from '@/lib/utils';
import LeaseBackSelectOptionPackage from '@/components/SelectOptionPackage'
import LTEModalApartmentLeasebackCompany from "@/components/LTEModalApartmentLeasebackCompany";
import SelectLeaseBackClientsModal from "@/components/SelectLeaseBackClientsModal.vue";
import LTEModalInvoiceGeneralInvoiceDetail from "@/components/LTEModalInvoiceGeneralInvoiceDetail";
import BookingStatusEnum from "@/enum/bookingStatusEnum";

export default {
    name: "LeaseBackApartmentBookingForGroup",
    data() {
        return {
            booking_id: 0,
            apartment_id: 0,
            disablecustomerform: false,
            ischeck: false,
            options: {
                format: "DD/MM/YYYY",
                useCurrent: false,
                //maxDate: moment().subtract(2, "days"),
            },
            dateTimeOptions: {
                format: "DD/MM/YYYY HH:mm",
                useCurrent: false,
                //maxDate: moment().subtract(2, "days"),
            },
            country_list: [],
            leaseback_company_list:[{value: null, text: "---"}],
            gender_list: constantsData.genderTypes,
            field_required:{
                'booking_person_name': '',
                'booking_person_email': '',
                'booking_person_phone':''
            },
            objectNameData: 'this.userdata.',
            objectNameRequire: 'this.field_required.',
            isLoading: false,
            isLoadingApartmentBookedList: false,
            isLoadingAvailableApartmentList: false,
            BookingStatusEnum: BookingStatusEnum,
            apartment_bookings: {
              booking_id: 0,
              booking_code: "",
              apartment: 0,
              booking_status: BookingStatusEnum.WAITING,
              other_booking_details:"",
              checkin_datetime:null,
              checkout_datetime:null,
              number_of_days:0,
              checkin_yn:false,
              pkg_template: null,
              booking_company: null,
              booking_person_name	:"",
              booking_person_email :"",
              booking_person_phone:"",
              total_deposit: 0,
              deposit:0,
              deposit_deadline: null,
              // [loitt] - #1171 GHI NHẬN THÔNG TIN XUẤT HOÁ ĐƠN
              company_name: "",
              company_address: "",
              company_tax_code: "",
              company_email: "",
              total_booking_room_rate_after_promotion: 0,
              booking_room_rate: 0,
              booking_room_rate_after_discount: 0,
              total_booking_room_rate_after_vat: 0,
              booking_room_rate_after_vat: 0,
              discount: 0,
              sale_off: 0,
              package_price_in_day: 0,
              package_summary: 0,
              modal_booking_room_rate: 0,
              modal_package_price_in_day: 0,
              booking_room_rate_backup: 0,
              ew_included: true,
              payment_duration_factor:1,
              start_e: 0,
              start_w: 0,
              pkg_other_detail: null,
              pkg_other_fee: 0,
              pkg_other_fee_vat: 0,
              total_pkg_other_fee_after_vat: 0, 
              package_price_in_day_after_discount: 0,
              pkg_other_vat: 0,
              vat: 0,

              initialize_deposit_request_from_db: 0 ,
              deposit_request: 0,
              payment_in_advance: 0,
              payment_inadvance_request: 0,
            },
            list_apartment_lease_back_clients_selected:[],
            on_deleted_apartment_lease_back_client: "",
            apartment_leaseback_clients: {
              id : 0,
              id_passsport: null,
              id_passsport_issued_date: null,
              dob: null,
              full_name: null,
              address: null,
              email: null,
              phone: null,
              gender: null,
              country_code: null,
              other_details: null,
              visa_number: '',
              visa_expired_date: null,
              vn_tmp_stay_start: null,
              vn_tmp_stay_end: null,
              represent: '',
              checkin_datetime: null,
              checkout_datetime: null,
              flight: null
            },
            apartmentSingleRoomAvailableBookingList: [],
            apartmentCoupleRoomAvailableBookingList: [],
            apartmentTripleRoomAvailableBookingList: [],
            singleApartmentData: {
              'stt': 1,
              'room_type': '1 PN',
              'price': 0,
              'total_room': 0,
              'total_booking_room': Number(0),
              'total_available_room': 0
            },
            coupleApartmentData: {
              'stt': 2,
              'room_type': '2 PN',
              'price': 0,
              'total_room': 0,
              'total_booking_room': Number(0),
              'total_available_room': 0
            },
            tripleApartmentData: {
              'stt': 3,
              'room_type': '3 PN',
              'price': 0,
              'total_room': 0,
              'total_booking_room': Number(0),
              'total_available_room': 0
            },
            bookingStatusCodes: constantsData.bookingStatusCode,
            apartmentBookedList: [],
            apartmentAvailableBookedFields: [
              { key: 'stt', label: "STT", class: 'text-center' },
              { key: 'apartment_code', label: 'Phòng', class: 'text-center' },
              { key: 'apartment_room_type', label: 'Loại Phòng', sortable: true, class: 'text-center' },
              { key: 'booking_room_rate', label: 'Giá Phòng', class: 'text-center'},
              { key: 'vat', label: 'Thuế (%)', class: 'text-center'},
              // { key: 'booking_room_rate', label: 'Booking Room Rate', class: 'text-center'},
              { key: 'booking_room_rate_vat', label: 'Giá Phòng Sau Thuế', class: 'text-center'},
              { key: 'booking_room_rate_daily', label: 'Giá Phòng / Ngày', class: 'text-center'},
              { key: 'pkg_template', label: 'Gói Dịch Vụ', class: 'text-center'},
              { key: 'payment_duration_factor', label: 'Thời Hạn Thanh Toán', class: 'text-center'},
              { key: 'booking_status', label: 'Trạng Thái Đặt Phòng', class: 'text-center'},
              { key: 'start_e', label: 'Chỉ Số Điện Gốc', class: 'text-center'},
              { key: 'start_w', label: 'Chỉ Số Nước Gốc', class: 'text-center'},
              { key: 'ew_included', label: 'Bao Điện Nước', class: 'text-center'},
              { key: 'other_fee', label: 'Chí Phí Khác', class: 'text-center'},
              { key: 'other_vat', label: 'Thuế Khác (%)', class: 'text-center'},
              { key: 'other_details', label: 'Chi Tiết Khác', class: 'text-center'},
              // { key: "actions", label: "common.action", class: 'text-center' }
            ],
            data_booking: [],
            paymentDurationFactor: constantsData.paymentDurationFactor,
            hour_default_checkin: null,
            minute_default_checkin: null,
            hour_default_checkout: null,
            minute_default_checkout: null
        };
    },

    watch: {
      GET_AVAILABLE_APARTMENT_DATA: function() {
        let availableApartmentData = this.GET_AVAILABLE_APARTMENT_DATA
        let isAvailableApartmentBooking = false
        // Set default value every load data to avoid duplicate data
        // Single room
        this.singleApartmentData.total_room = 0
        this.singleApartmentData.total_booking_room = 0
        this.singleApartmentData.total_available_room = 0
        // Couple room
        this.coupleApartmentData.total_room = 0
        this.coupleApartmentData.total_booking_room = 0
        this.coupleApartmentData.total_available_room = 0
        // Triple room
        this.tripleApartmentData.total_room = 0
        this.tripleApartmentData.total_booking_room = 0
        this.tripleApartmentData.total_available_room = 0
        for (let i = 0, size = availableApartmentData.length; i < size; i++) {
          if (availableApartmentData[i].booking.booking_status != BookingStatusEnum.CONFIRMED && availableApartmentData[i].booking.booking_status != BookingStatusEnum.ONBOARD) {
            if (availableApartmentData[i].bedroom_count == 1) {
              isAvailableApartmentBooking = false
              this.singleApartmentData.total_room += 1
              if (availableApartmentData[i].booking.booking_status != BookingStatusEnum.WAITING) {
                isAvailableApartmentBooking = false
              } else {
                this.singleApartmentData.total_available_room += 1
                isAvailableApartmentBooking = true
              }
              if (isAvailableApartmentBooking) {
                let apartmentAvailableObject = {
                  'is_checked': false,
                  'apartment_code': availableApartmentData[i].apartment_code,
                  'apartment_room_type': '1 PN',
                  'booking_room_rate': 0,
                  'booking_room_rate_vat': 0,
                  'booking_room_rate_daily': 0,
                  'booking_status': null,
                  'start_e': 0,
                  'start_w': 0,
                  'ew_included': true,
                  'other_details': '',
                  'other_fee': 0,
                  'other_vat': 0,
                  'vat': 0,
                  'apartment': availableApartmentData[i].id,
                  'pkg_template': null
                }
                this.apartmentSingleRoomAvailableBookingList.push(apartmentAvailableObject)
              }
            } else if (availableApartmentData[i].bedroom_count == 2) {
              isAvailableApartmentBooking = false
              this.coupleApartmentData.total_room += 1
              if (availableApartmentData[i].booking.booking_status != BookingStatusEnum.WAITING) {
                isAvailableApartmentBooking = false
              } else {
                this.coupleApartmentData.total_available_room += 1
                isAvailableApartmentBooking = true
              }
              if (isAvailableApartmentBooking) {
                let apartmentAvailableObject = {
                  'is_checked': false,
                  'apartment_code': availableApartmentData[i].apartment_code,
                  'apartment_room_type': '2 PN',
                  'booking_room_rate': 0,
                  'booking_room_rate_vat': 0,
                  'booking_status': null,
                  'booking_room_rate_daily': 0,
                  'start_e': 0,
                  'start_w': 0,
                  'ew_included': true,
                  'other_details': '',
                  'other_fee': 0,
                  'other_vat': 0,
                  'vat': 0,
                  'apartment': availableApartmentData[i].id,
                  'pkg_template': null
                }
                this.apartmentCoupleRoomAvailableBookingList.push(apartmentAvailableObject)
              }
            } else if (availableApartmentData[i].bedroom_count == 3) {
              isAvailableApartmentBooking = false
              this.tripleApartmentData.total_room += 1
              if (availableApartmentData[i].booking.booking_status != BookingStatusEnum.WAITING) {
                isAvailableApartmentBooking = false
              } else {
                this.tripleApartmentData.total_available_room += 1
                isAvailableApartmentBooking = true
              }
              if (isAvailableApartmentBooking) {
                let apartmentAvailableObject = {
                  'is_checked': false,
                  'apartment_code': availableApartmentData[i].apartment_code,
                  'apartment_room_type': '3 PN',
                  'booking_room_rate': 0,
                  'booking_room_rate_vat': 0,
                  'booking_room_rate_daily': 0,
                  'booking_status': null,
                  'start_e': 0,
                  'start_w': 0,
                  'ew_included': true,
                  'other_details': '',
                  'other_fee': 0,
                  'other_vat': 0,
                  'vat': 0,
                  'apartment': availableApartmentData[i].id,
                  'pkg_template': null
                }
                this.apartmentTripleRoomAvailableBookingList.push(apartmentAvailableObject)
              }
            }
          }
        }
        // Set some apartment checked from db
        this.singleApartmentData.total_booking_room = 0
        this.coupleApartmentData.total_booking_room = 0
        this.tripleApartmentData.total_booking_room = 0
        for (let j = 0, sizeApartmentBooked = this.apartmentBookedList.length; j < sizeApartmentBooked; j++) {
          for (let n = 0; n < this.apartmentSingleRoomAvailableBookingList.length; n++) {
            if (this.apartmentBookedList[j].apartment_code == this.apartmentSingleRoomAvailableBookingList[n].apartment_code) {
              this.apartmentSingleRoomAvailableBookingList[n].is_checked = true
              this.singleApartmentData.total_booking_room += 1
            }
          }
          for (let m = 0; m < this.apartmentCoupleRoomAvailableBookingList.length; m++) {
            if (this.apartmentBookedList[j].apartment_code == this.apartmentCoupleRoomAvailableBookingList[m].apartment_code) {
              this.apartmentCoupleRoomAvailableBookingList[m].is_checked = true
              this.coupleApartmentData.total_booking_room += 1
            }
          }
          for (let z = 0; z < this.apartmentTripleRoomAvailableBookingList.length; z++) {
            if (this.apartmentBookedList[j].apartment_code == this.apartmentTripleRoomAvailableBookingList[z].apartment_code) {
              this.apartmentTripleRoomAvailableBookingList[z].is_checked = true
              this.tripleApartmentData.total_booking_room += 1
            }
          }
        }
        this.isLoadingAvailableApartmentList = false
      },
      GET_GROUP_BOOKING_DETAIL_DATA: function() {
        let data = this.GET_GROUP_BOOKING_DETAIL_DATA
        let booking_group_detail_data = data.apartment_booking_group_detail
        // Booking code
        this.apartment_bookings.booking_code = booking_group_detail_data.booking_code
        // For personal
        this.apartment_bookings.booking_company = booking_group_detail_data.booking_company
        this.apartment_bookings.booking_person_name = booking_group_detail_data.booking_person_name
        this.apartment_bookings.booking_person_email = booking_group_detail_data.booking_person_email
        this.apartment_bookings.booking_person_phone = booking_group_detail_data.booking_person_phone
        // For company
        this.apartment_bookings.company_name = booking_group_detail_data.company_name
        this.apartment_bookings.company_address = booking_group_detail_data.company_address
        this.apartment_bookings.company_tax_code = booking_group_detail_data.company_tax_code
        this.apartment_bookings.company_email = booking_group_detail_data.company_email
        // Other booking detail
        this.apartment_bookings.other_booking_details = booking_group_detail_data.other_booking_details
        this.apartment_bookings.discount = utils.formatNumber(booking_group_detail_data.discount)
        this.apartment_bookings.sale_off = booking_group_detail_data.sale_off
        this.apartment_bookings.deposit_request =  utils.formatNumber(Math.round(booking_group_detail_data.deposit_request))
        this.apartment_bookings.payment_inadvance_request = utils.formatNumber(Math.round(booking_group_detail_data.payment_inadvance_request))
        this.onChangeDepositRequestOrPaymentInadvanceRequest()
        this.apartment_bookings.checkin_datetime = utils.addTimeZoneForTimestamp(booking_group_detail_data.checkin_datetime, this.options.format)
        this.apartment_bookings.checkout_datetime = utils.addTimeZoneForTimestamp(booking_group_detail_data.checkout_datetime, this.options.format)
        // Get deposit
        let deposit = booking_group_detail_data.deposit
        let payment_in_advance = booking_group_detail_data.payment_in_advance
        this.apartment_bookings.deposit = utils.formatNumber(deposit)
        this.apartment_bookings.payment_in_advance = utils.formatNumber(payment_in_advance)
        // Get deposit deadline
        this.getDepositDeadline(booking_group_detail_data.checkin_datetime, booking_group_detail_data.deposit_deadline)
        // booking clients
        let list_apartment_lease_back_clients_selected = []
        booking_group_detail_data.apartment_lease_back_group_clients_ids.forEach(v => {
          if (v.main_contact) {
            v.client_details['selected'] = true
          } else {
            v.client_details['selected'] = false
          }
          list_apartment_lease_back_clients_selected.push(v.client_details)
        })
        let main_contact = false
        for (let i = 0, size = list_apartment_lease_back_clients_selected.length; i < size; i++) {
          main_contact = list_apartment_lease_back_clients_selected[i].selected
        }
        if (!main_contact) {
          if (list_apartment_lease_back_clients_selected.length != 0) {
            list_apartment_lease_back_clients_selected[0]['selected'] = true
          }
        }
        this.list_apartment_lease_back_clients_selected = list_apartment_lease_back_clients_selected
        this.apartmentBookedList = []
        let apartmentInGroupBookingIds = booking_group_detail_data.apartment_in_group_booking_ids
        // Booking status code
        this.apartment_bookings.booking_status = apartmentInGroupBookingIds[0].booking_status
        for (let i = 0, size = apartmentInGroupBookingIds.length; i < size; i++) {
          let object = {
            'is_checked': true,
            'apartment_code': apartmentInGroupBookingIds[i].apartment_details.apartment_code,
            'apartment_room_type': apartmentInGroupBookingIds[i].apartment_details.bedroom_count == 1 ? '1 PN' : (apartmentInGroupBookingIds[i].apartment_details.bedroom_count == 2 ? '2 PN' : '3 PN'),
            'booking_room_rate': apartmentInGroupBookingIds[i].booking_room_rate,
            'booking_room_rate_vat': apartmentInGroupBookingIds[i].booking_room_rate_vat,
            'booking_room_rate_daily': apartmentInGroupBookingIds[i].booking_room_rate_daily,
            'start_e': apartmentInGroupBookingIds[i].start_e,
            'start_w': apartmentInGroupBookingIds[i].start_w,
            'ew_included': apartmentInGroupBookingIds[i].ew_included,
            'other_details': apartmentInGroupBookingIds[i].other_details,
            'other_fee': utils.formatNumber(apartmentInGroupBookingIds[i].other_fee),
            'other_vat': apartmentInGroupBookingIds[i].other_vat,
            'vat': 0,
            'apartment': apartmentInGroupBookingIds[i].apartment_details.id,
            'pkg_template': apartmentInGroupBookingIds[i].pkg_template,
            'booking_status': apartmentInGroupBookingIds[i].booking_status
          }
          this.apartmentBookedList.push(object)
        }
        for (let j = 0, sizeApartmentBooked = this.apartmentBookedList.length; j < sizeApartmentBooked; j++) {
          this.apartmentBookedList[j]['stt'] = j + 1
        }
        this.calculatorAmount(this.apartmentBookedList)
        this.isLoadingApartmentBookedList = false
      }
    },

    computed: {
      ...mapGetters([
        "GET_SNACK_BAR",
        "GET_AVAILABLE_APARTMENT_DATA",
        "GET_GROUP_BOOKING_DETAIL_DATA",
        "GET_LEASEBACK_COMPANY_DATA"
      ]),
      get_number_of_days: function() {
        let checkin = utils.formatSqlDate(this.apartment_bookings.checkin_datetime, "DD/MM/YYYY", "MM/DD/YYYY")
        let checkout = utils.formatSqlDate(this.apartment_bookings.checkout_datetime, "DD/MM/YYYY", "MM/DD/YYYY")
        let number_of_days = utils.datediff(checkin, checkout) == 'NaN' ? 0 : utils.datediff(checkin, checkout);
        return number_of_days
      }
    },

    methods: {
        ...mapActions([
            "ERROR_TOAST",
            "SUCCESS_TOAST",
            "ON_SHOW_TOAST",
            "GET_APARTMENT_LEASEBACK_CLIENTS_LIST",
            "GET_LEASEBACK_COMPANY_LIST",
            "GET_AVAILABLE_APARTMENT_LIST",
            "ADD_APARTMENT_LEASEBACK_CLIENTS",
            "GET_COUNTRY_LIST",
            "ADD_APARTMENT_GROUP_BOOKINGS",
            "UPDATE_APARTMENT_GROUP_BOOKINGS",
            "GET_GROUP_BOOKING_DETAIL",
            "UPDATE_APARTMENT_LEASEBACK_CLIENTS",
            "CANCEL_APARTMENT_BOOKING_GROUP",
            "GET_PROJECT_DETAIL"
        ]),
        ...mapActions("bookingModule", [
        ]),
        onChangeCompany: function(val) {
          if(val == null){
            this.apartment_bookings.company_email = ""
            this.apartment_bookings.company_tax_code = ""
            this.apartment_bookings.company_name = ""
            this.apartment_bookings.company_address = ""
          } else {
            const result = this.GET_LEASEBACK_COMPANY_DATA.find( ({ id }) => id === val );
            this.apartment_bookings.company_email = result.email
            this.apartment_bookings.company_tax_code = result.tax_code
            this.apartment_bookings.company_name = result.name
            this.apartment_bookings.company_address = result.address
          }
        },
        sendEmailConfirmedBooking() {
          let routeData = this.$router.resolve({
            name: "ConfirmedApartmentBookingGroupPdf",
            params: {
              id: this.booking_id
            }
          });
          window.open(routeData.href, "_blank");
        },
        onInvoiceGeneralInvoiceSuccess: function(){
          // alert OK
          if (this.booking_id !== 0) {
            this.isLoadingApartmentBookedList = true
            this.GET_GROUP_BOOKING_DETAIL({id: this.booking_id})
          }
        },
        formatDeposit() {
          let deposits =[]
          deposits.push(utils.formatInteger(this.apartment_bookings.deposit.toString()))
          this.apartment_bookings.deposit = utils.formatNumber(deposits[deposits.length - 1])
        },
        formatPaymentInAdvance() {
          let PaymentInAdvances =[]
          PaymentInAdvances.push(utils.formatInteger(this.apartment_bookings.payment_in_advance.toString()))
          this.apartment_bookings.payment_in_advance = utils.formatNumber(PaymentInAdvances[PaymentInAdvances.length - 1])
        },
        onClickShowInvoiceGeneralInvoiceDeposit: function(){
          // call function from model (To set value call back from BOOKING)
          this.$refs.modalInvoiceGeneralInvoiceDetail.setCallBackFrom("BOOKING")
          let object_data_default = {
            amount: 0,
            customer: this.apartment_bookings.booking_person_name,
            description: "Đặt Cọc Cho Mã Booking " + this.apartment_bookings.booking_code,
            purpose: 1, // 1. booking_deposit (phiếu thu tiền đặt coc)
            correlation_key: this.apartment_bookings.booking_code,
            deposit_deadline: this.apartment_bookings.deposit_deadline,
            booking_code: this.apartment_bookings.booking_code
          }
          this.$refs.modalInvoiceGeneralInvoiceDetail.setValueDefault(object_data_default)
          // Show invoice general invoice
          this.$refs.modalInvoiceGeneralInvoiceDetail.submit(0);
        }, 
        onClickShowInvoiceGeneralInvoicePaymentInAdvance: function(){
          // call function from model (To set value call back from BOOKING)
          this.$refs.modalInvoiceGeneralInvoiceDetail.setCallBackFrom("BOOKING")
          let object_data_default = {
            amount: 0,
            customer: this.apartment_bookings.booking_person_name,
            description: "Tiền Trả Trước Cho Mã Booking " + this.apartment_bookings.booking_code,
            purpose: 2, // 2. booking_paymentinadvance (phiếu thu tiền trả trước)
            correlation_key: this.apartment_bookings.booking_code,
            deposit_deadline: this.apartment_bookings.deposit_deadline,
            booking_code: this.apartment_bookings.booking_code
          }
          this.$refs.modalInvoiceGeneralInvoiceDetail.setValueDefault(object_data_default)
          // Show invoice general invoice
          this.$refs.modalInvoiceGeneralInvoiceDetail.submit(0);
        }, 
        confirmCancelApartmentBooking: function() {
          this.waitingLoading(true)
          $("#modal-cancel-apartment-booking").modal("hide");
          this.CANCEL_APARTMENT_BOOKING_GROUP({id: this.booking_id, other_booking_details: this.apartment_bookings.other_booking_details}).then(
            function(res) {
              this.waitingLoading(false)
              this.SUCCESS_TOAST()
            }.bind(this)
          ).catch(
            function(error) {
              let error_code = error.response.data.error_code
              if (error_code == 'is_canceled_out') {
                this.waitingLoading(false)
                this.ON_SHOW_TOAST({
                  message: "Bạn đã hủy đặt phòng rồi.",
                  styleType: "danger"
                })
              } else if (error_code == 'is_checked_in') {
                this.waitingLoading(false)
                this.ON_SHOW_TOAST({
                  message: "Bạn Đã Nhận Phòng Nên Không Thể Hủy Đặt Phòng.",
                  styleType: "danger"
                })
              } else if (error_code == 'is_checked_out') {
                this.waitingLoading(false)
                this.ON_SHOW_TOAST({
                  message: "Bạn Đã Trả Phòng Nên Không Thể Hủy Đặt Phòng.",
                  styleType: "danger"
                })
              } else {
                this.waitingLoading(false)
                this.ERROR_TOAST()
              }
            }.bind(this)
          )
        },
        getBookingStatusCode: function(bookingStatusCode) {
          if (!utils.isNull(bookingStatusCode)) {
            if (bookingStatusCode == 1) {
              return this.$t('apartment.reservations.waiting')
            } else if (bookingStatusCode == 2) {
              return this.$t('apartment.reservations.confirmed')
            } else if (bookingStatusCode == 3) {
              return this.$t('apartment.reservations.reserved')
            } else if (bookingStatusCode == 4) {
              return this.$t('apartment.reservations.deposit')
            } else if (bookingStatusCode == 5) {
              return this.$t('apartment.reservations.paid')
            } else if (bookingStatusCode == 6) {
              return this.$t('apartment.reservations.cancelled')
            } else if (bookingStatusCode == 7) {
              return this.$t('apartment.reservations.pending')
            } else if (bookingStatusCode == 8) {
              return this.$t('apartment.reservations.onboard')
            } else if (bookingStatusCode == 9) {
              return this.$t('apartment.reservations.expired')
            } else if (bookingStatusCode == 10) {
              return this.$t('apartment.reservations.checkedout')
            } else if (bookingStatusCode == 11) {
              return this.$t('apartment.reservations.checkin_comming_soon')
            } else if (bookingStatusCode == 12) {
              return this.$t('apartment.reservations.checkout_comming_soon')
            }
          } else {
            return ''
          }
        },
        onChangeDepositDate: function() {
          // Todo
        },
        selectMainContact: function(item) {
          for (let i = 0, size = this.list_apartment_lease_back_clients_selected.length; i < size; i++) {
            if (item.id != this.list_apartment_lease_back_clients_selected[i].id) {
              this.list_apartment_lease_back_clients_selected[i].selected = false
            } else {
              this.list_apartment_lease_back_clients_selected[i].selected = true
            }
          }
        },
        onDeleteApartmentLeaseBackClient (item) {
          $('#modal-apartment-leaseback-client-delete').modal('show')
          this.on_deleted_apartment_lease_back_client = item
        },
        onEditApartmentLeaseBackClient(item){
          // Check-in date time
          if (!utils.isNull(item.checkin_datetime)) {
            item.checkin_datetime = utils.formatDateTimeWithHour(item.checkin_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm')
          } else {
            item.checkin_datetime = null
          }
          // Check-out date time
          if (!utils.isNull(item.checkout_datetime)) {
            item.checkout_datetime = utils.formatDateTimeWithHour(item.checkout_datetime, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY HH:mm')
          } else {
            item.checkout_datetime = null
          }
          // Visa expired date
          if (!utils.isNull(item.visa_expired_date)) {
            item.visa_expired_date = utils.formatDateTime(item.visa_expired_date, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY')
          } else {
            item.visa_expired_date = null
          }
          // Visa stay start
          if (!utils.isNull(item.vn_tmp_stay_start)) {
            item.vn_tmp_stay_start = utils.formatDateTime(item.vn_tmp_stay_start, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY')
          } else {
            item.vn_tmp_stay_start = null
          }
          // Visa stay end
          if (!utils.isNull(item.vn_tmp_stay_end)) {
            item.vn_tmp_stay_end = utils.formatDateTime(item.vn_tmp_stay_end, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY')
          } else {
            item.vn_tmp_stay_end = null
          }
          // Passport due date
          if (!utils.isNull(item.id_passsport_issued_date)) {
            item.id_passsport_issued_date = utils.formatDateTime(item.id_passsport_issued_date, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY')
          } else {
            item.id_passsport_issued_date = null
          }
          // Dob
          if (!utils.isNull(item.dob)) {
            item.dob = utils.formatDateTime(item.dob, 'YYYY-MM-DDTHH:mm:ss.sssZ', 'DD/MM/YYYY')
          } else {
            item.dob = null
          }
          // Country
          if (!utils.isNull(item.country)) {
            this.apartment_leaseback_clients.country_code = item.country
            item.country_code = item.country
          } else {
            this.apartment_leaseback_clients.country_code = null
            item.country_code = null
          }
          this.apartment_leaseback_clients = item
        },
        getCountryName: function(country_id) {
          for (let i = 0, size = this.country_list.length; i < size; i++) {
            if (country_id == this.country_list[i].value) {
              return this.country_list[i].text
            }
          }
        },
        onChangeDepositRequestOrPaymentInadvanceRequest: function() {
          let int_deposit_request = utils.formatInteger(this.apartment_bookings.deposit_request.toString())
          this.apartment_bookings.deposit_request = utils.formatNumber(int_deposit_request)
          let payment_inadvance_request = utils.formatInteger(this.apartment_bookings.payment_inadvance_request.toString())
          this.apartment_bookings.payment_inadvance_request = utils.formatNumber(payment_inadvance_request)
          this.apartment_bookings.total_deposit = utils.formatNumber(Number(utils.formatInteger(this.apartment_bookings.deposit_request.toString())) + Number(utils.formatInteger(this.apartment_bookings.payment_inadvance_request.toString())))
        },
        selectedItemLeaseBackClient: function(){
          return false
        },
        formatDateTimeWithHour: function(dateTime, fromFormat, toFormat) {
          if (!utils.isNull(dateTime)) {
            return utils.formatDateTimeWithHour(dateTime, fromFormat, toFormat)
          }
        },
        formatOtherFee: function(row) {
          let otherFeeInteger = utils.formatInteger(row.item.other_fee.toString())
          row.item.other_fee = utils.formatNumber(otherFeeInteger)
        },
        formatDateTime: function(dateTime, fromFormat, toFormat) {
          if (!utils.isNull(dateTime)) {
            return utils.formatDateTime(dateTime, fromFormat, toFormat)
          }
        },
        waitingLoading: function(bol) {
          this.isLoading = bol;
        },
        onChangeSelect: function(pkg, row) {
          row.pkg_template = pkg.id
        },
        onPackageOneMonthObject: function(objPackageOneMonth, item) {
          item.booking_room_rate = utils.formatNumber(objPackageOneMonth[0].price)
          item.booking_room_rate_vat = utils.formatNumber(objPackageOneMonth[0].priceAfterVAT)
          item.payment_duration_factor = objPackageOneMonth[0].payment_duration_factor
          item.vat = objPackageOneMonth[0].vat
          let number_of_day_in_package = objPackageOneMonth[0].payment_duration_factor == 1 ? 30 : (objPackageOneMonth[0].payment_duration_factor == 2 ? 7 : 1)
          item.booking_room_rate_daily = utils.formatNumber(Math.round(objPackageOneMonth[0].price / number_of_day_in_package))
          this.calculatorAmount(this.apartmentBookedList)
        },
        onPackageCurrent: function(objPackageOneMonth, item) {
          item.booking_room_rate = utils.formatNumber(objPackageOneMonth[0].price)
          item.booking_room_rate_vat = utils.formatNumber(objPackageOneMonth[0].priceAfterVAT)
          item.payment_duration_factor = objPackageOneMonth[0].payment_duration_factor
          item.vat = objPackageOneMonth[0].vat
          let number_of_day_in_package = objPackageOneMonth[0].payment_duration_factor == 1 ? 30 : (objPackageOneMonth[0].payment_duration_factor == 2 ? 7 : 1)
          item.booking_room_rate_daily = utils.formatNumber(Math.round(objPackageOneMonth[0].price / number_of_day_in_package))
          this.calculatorAmount(this.apartmentBookedList)
        },
        calculatorAmountWithDiscount: function(packageSummary, discount) {
          let summary = (packageSummary - Math.round((packageSummary * discount / 100)))
          return summary
        },
        calculatorAmount: function(feeInBookedList) {
          // Total after vat set value default = 0
          this.apartment_bookings.total_booking_room_rate_after_vat = 0
          // Total set value default = 0
          this.apartment_bookings.package_summary = 0
          // Tax set value default = 0
          this.apartment_bookings.booking_room_rate_after_vat = 0
          // Total booking room rate after promotion set value default = 0
          this.apartment_bookings.total_booking_room_rate_after_promotion = 0
          // Calculator total and tax
          for (let i = 0, size = feeInBookedList.length; i < size; i++) {
            /**
             * Param 1: Package summary (Tổng tiền trước thuế)
             * Param 2: Discount (Giảm Giá)
             */
            let package_summary_with_discount_promotion = this.calculatorAmountWithDiscount((utils.formatInteger(feeInBookedList[i].booking_room_rate_daily.toString()) * this.get_number_of_days), utils.formatInteger(this.apartment_bookings.sale_off.toString()))
            // Calculator total
            this.apartment_bookings.package_summary += package_summary_with_discount_promotion
            // Calculator tax
            this.apartment_bookings.booking_room_rate_after_vat += Math.round(package_summary_with_discount_promotion * (feeInBookedList[i].vat / 100))
          }
          // Format discount
          let discount = utils.formatInteger(this.apartment_bookings.discount.toString())
          this.apartment_bookings.discount = utils.formatNumber(discount)
          // Format sale off
          let sale_off = utils.formatInteger(this.apartment_bookings.sale_off.toString())
          this.apartment_bookings.sale_off = utils.formatNumber(sale_off)
          // Format number package summary
          this.apartment_bookings.package_summary = utils.formatNumber(this.apartment_bookings.package_summary)
          // Format number tax
          this.apartment_bookings.booking_room_rate_after_vat = utils.formatNumber(this.apartment_bookings.booking_room_rate_after_vat)
          // Format number total room rate after vat
          this.apartment_bookings.total_booking_room_rate_after_vat = utils.formatNumber(Number(utils.formatInteger(this.apartment_bookings.package_summary.toString())) + Number(utils.formatInteger(this.apartment_bookings.booking_room_rate_after_vat.toString())))
          // Calculator and format number total room rate with vat and with promotion
          this.apartment_bookings.total_booking_room_rate_after_promotion = utils.formatNumber(utils.formatInteger(this.apartment_bookings.total_booking_room_rate_after_vat.toString()) - Number(utils.formatInteger(this.apartment_bookings.discount.toString())))
          /**
           * EN: Deposit request, Payment Inadvance Request
           * VI: Đặt cọc giữ chỗ, Trả trước giữ chỗ
           */
          this.apartment_bookings.deposit_request = this.apartment_bookings.total_booking_room_rate_after_promotion
          this.apartment_bookings.payment_inadvance_request = utils.formatNumber(Math.round(utils.formatInteger(this.apartment_bookings.deposit_request.toString()) * 0.5))
          // Total deposit
          this.apartment_bookings.total_deposit = utils.formatNumber(Number(utils.formatInteger(this.apartment_bookings.deposit_request.toString())) + Number(utils.formatInteger(this.apartment_bookings.payment_inadvance_request.toString())))
          // Set default is 0 if number is negative number
          if (utils.formatInteger(this.apartment_bookings.total_booking_room_rate_after_vat.toString()) < 0) {
            this.apartment_bookings.total_booking_room_rate_after_vat = 0
            this.apartment_bookings.deposit_request = 0
            this.apartment_bookings.payment_inadvance_request = 0
            this.apartment_bookings.total_deposit = 0
          }
        },
        onChangeBookingRoom: function(roomType) {
          let total_checked = 0
          let apartmentRoomAvailableBookingList = roomType == 'single' ? this.apartmentSingleRoomAvailableBookingList : (roomType == 'couple' ? this.apartmentCoupleRoomAvailableBookingList : this.apartmentTripleRoomAvailableBookingList)
          let apartmentData = roomType == 'single' ? this.singleApartmentData : (roomType == 'couple' ? this.coupleApartmentData : this.tripleApartmentData)
          for (let i = 0, size = apartmentRoomAvailableBookingList.length; i < size; i++) {
            if (apartmentRoomAvailableBookingList[i].is_checked) {
              total_checked += 1
            }
          }
          let numberSingleBooking = 0
          if (apartmentData.total_booking_room < total_checked) {
            numberSingleBooking = total_checked - apartmentData.total_booking_room
          } else {
            numberSingleBooking = apartmentData.total_booking_room - total_checked
          }
          let countNumberBooking = 0
          for (let j = 0, sizeNumberBooked = apartmentRoomAvailableBookingList.length; j < sizeNumberBooked; j++) {
            if (apartmentData.total_booking_room < total_checked) {
              if (apartmentRoomAvailableBookingList[j].is_checked) {
                countNumberBooking += 1
                apartmentRoomAvailableBookingList[j].is_checked = false
                this.apartmentBookedList.filter((item, index) => {
                  if (item.apartment_code == apartmentRoomAvailableBookingList[j].apartment_code) {
                    this.apartmentBookedList.splice(index, 1)
                  }
                });
              }
            } else if (apartmentData.total_booking_room > total_checked) {
              if (!apartmentRoomAvailableBookingList[j].is_checked) {
                countNumberBooking += 1
                apartmentRoomAvailableBookingList[j].is_checked = true
                this.apartmentBookedList.push(apartmentRoomAvailableBookingList[j])
              }
            }
            if (countNumberBooking == numberSingleBooking) {
              break;
            }
          }
          for (let j = 0, sizeApartmentBooked = this.apartmentBookedList.length; j < sizeApartmentBooked; j++) {
            this.apartmentBookedList[j]['stt'] = j + 1
          }
          // Calculator some fee
          this.calculatorAmount(this.apartmentBookedList)
        },
        selectApartmentAvailable: function(event, item, index) {
          event.preventDefault();
          item.is_checked = !item.is_checked
          if (!item.is_checked) {
            if (item.apartment_room_type == '1 PN') {
              this.singleApartmentData.total_booking_room = Number(this.singleApartmentData.total_booking_room) - 1
            } else if (item.apartment_room_type == '2 PN') {
              this.coupleApartmentData.total_booking_room = Number(this.coupleApartmentData.total_booking_room) - 1
            } else if (item.apartment_room_type == '3 PN') {
              this.tripleApartmentData.total_booking_room = Number(this.tripleApartmentData.total_booking_room) - 1
            }
            this.apartmentBookedList.filter((item, index) => {
              if (!item.is_checked) {
                this.apartmentBookedList.splice(index, 1)
              }
            });
          } else {
            if (item.apartment_room_type == '1 PN') {
              this.singleApartmentData.total_booking_room = Number(this.singleApartmentData.total_booking_room) + 1
            } else if (item.apartment_room_type == '2 PN') {
              this.coupleApartmentData.total_booking_room = Number(this.coupleApartmentData.total_booking_room) + 1
            } else if (item.apartment_room_type == '3 PN') {
              this.tripleApartmentData.total_booking_room = Number(this.tripleApartmentData.total_booking_room) + 1
            }
            this.apartmentBookedList.push(item)
          }
          for (let i = 0, size = this.apartmentBookedList.length; i < size; i++) {
            this.apartmentBookedList[i]['stt'] = i + 1
          }
          // Calculator some fee
          this.calculatorAmount(this.apartmentBookedList)
        },
        validateFieldIsEmpty: function(field, objectName = 'this.customerdata.',  objectNameRequire = 'this.field_required.' ) {
          // use for get value : this.userdata.last_name
          let exec = objectName + field
          // this.field_required.last_name
          let error_msg = objectNameRequire + field
          // Init data befor check
          eval(error_msg + " = ''")
          // ==> get value current
          let result = eval(exec)
          if (result == null || result == "") {
              eval(error_msg + " = 'common.error_msg[0].required'")
          }
          return result;
        },
        checkForm: function(objectName) {
            let result_error = "OK"
            for (var key in this.field_required)
            {
                if(key === 'email'){
                    this.validateEmailAll(key);
                } else {
                   if(!(key === 'password' && this.$route.query.apartment_id != 0)){
                        this.validateFieldIsEmpty(key, objectName);
                    }
                }
                let key_error = this.objectNameRequire + key
                let  t_result = eval(key_error)
                if( t_result != ''){
                    result_error = t_result
                }
            }

            return result_error
        },
        getDepositDeadline: function(checkin_datetime, deposit_deadline) {
          if (utils.isNull(deposit_deadline)) {
            let checkin = utils.formatSqlDate(checkin_datetime, "DD/MM/YYYY", "MM/DD/YYYY")
            let booking_date = moment(new Date(), "DD/MM/YYYY").format("MM/DD/YYYY")
            let number_of_days = utils.datediff(booking_date, checkin) == 'NaN' ? 0 : utils.datediff(booking_date, checkin);
            if (number_of_days > 7) {
              this.apartment_bookings.deposit_deadline = moment(checkin_datetime, "DD/MM/YYYY").subtract(7, 'days')
            } else if (number_of_days > 2) {
              this.apartment_bookings.deposit_deadline = moment(checkin_datetime, "DD/MM/YYYY").subtract(2, 'days')
            } else if (number_of_days > 1) {
              this.apartment_bookings.deposit_deadline = moment(checkin_datetime, "DD/MM/YYYY").subtract(1, 'days')
            } else {
              this.apartment_bookings.deposit_deadline = moment(new Date(), "DD/MM/YYYY").format("DD/MM/YYYY")
            }
          } else {
            this.apartment_bookings.deposit_deadline = utils.formatSqlDate(deposit_deadline, null, "DD/MM/YYYY")
          }
        },
        saveBooking: function(booking_status = null) {
          let result = this.checkForm('this.apartment_bookings.');
          if (result == "OK") {
            let data_booking = {}
            let checkin_datetime = new Date(utils.formatSqlDate(this.apartment_bookings.checkin_datetime, "DD-MM-YYYY", "YYYY-MM-DD"))
            let checkout_datetime = new Date(utils.formatSqlDate(this.apartment_bookings.checkout_datetime, "DD-MM-YYYY", "YYYY-MM-DD"))
            checkin_datetime.setHours(this.hour_default_checkin);
            checkin_datetime.setMinutes(this.minute_default_checkin);
            checkout_datetime.setHours(this.hour_default_checkout);
            checkout_datetime.setMinutes(this.minute_default_checkout);
            let deposit_deadline = new Date(utils.formatSqlDate(this.apartment_bookings.deposit_deadline, "DD-MM-YYYY", "YYYY-MM-DD"))
            let apartment_lease_back_group_clients_ids = []
            if(this.list_apartment_lease_back_clients_selected.length > 0){
              this.list_apartment_lease_back_clients_selected.forEach(v=> {
                let client_item = {
                  client: v.id,
                  main_contact: v.selected ? v.selected : false
                }
                apartment_lease_back_group_clients_ids.push(client_item)
              })
            }
            let discount = (this.apartment_bookings.discount == 0) ? 0 : utils.formatInteger(this.apartment_bookings.discount.toString())
            let sale_off = (this.apartment_bookings.sale_off == 0) ? 0 : utils.formatInteger(this.apartment_bookings.sale_off.toString())
            data_booking = {
              "booking_status": booking_status,
              "booking_code": this.apartment_bookings.booking_code,
              "other_booking_details": this.apartment_bookings.other_booking_details,
              "checkin_datetime": utils.addTimeZoneForTimestamp(checkin_datetime),
              "checkout_datetime": utils.addTimeZoneForTimestamp(checkout_datetime),
              "checkin_yn": this.apartment_bookings.checkin_yn,
              "booking_company": this.apartment_bookings.booking_company,
              "booking_person_name"	:this.apartment_bookings.booking_person_name,
              "booking_person_email" :this.apartment_bookings.booking_person_email,
              "booking_person_phone":this.apartment_bookings.booking_person_phone,
              "deposit": this.apartment_bookings.deposit !==0 ? utils.formatInteger(this.apartment_bookings.deposit.toString()) : this.apartment_bookings.deposit,
              "deposit_deadline": deposit_deadline,
              "payment_in_advance": this.apartment_bookings.payment_in_advance !== 0 ? utils.formatInteger(this.apartment_bookings.payment_in_advance.toString()) : this.apartment_bookings.payment_in_advance,
              "discount":  discount,
              "sale_off": sale_off,
              "company_name": this.apartment_bookings.company_name,
              "company_address": this.apartment_bookings.company_address,
              "company_tax_code": this.apartment_bookings.company_tax_code,
              "company_email": this.apartment_bookings.company_email,
              // cho phep edit tra truoc, dat coc tra truoc
              "deposit_request": this.apartment_bookings.deposit_request !==0 ? utils.formatInteger(this.apartment_bookings.deposit_request.toString()) : this.apartment_bookings.deposit_request,
              "payment_inadvance_request": this.apartment_bookings.payment_inadvance_request !==0 ? utils.formatInteger(this.apartment_bookings.payment_inadvance_request.toString()) : this.apartment_bookings.payment_inadvance_request,
              "apartment_lease_back_group_clients_ids": apartment_lease_back_group_clients_ids,
              "apartment_in_group_booking_ids": this.apartmentBookedList
            }
            this.data_booking = data_booking
            if (this.booking_id == 0 && booking_status != BookingStatusEnum.CANCELLED) {
              this.waitingLoading(true)
              this.ADD_APARTMENT_GROUP_BOOKINGS(data_booking).then(
                function (res) {
                  this.waitingLoading(false)
                  this.ON_SHOW_TOAST({
                    message: this.$t('customer.booking_successfully'),
                    styleType: "success"
                  });
                  // this.callBackToList()
                }.bind(this)
              ).catch(
                function (error) {
                  this.waitingLoading(false)
                  this.ON_SHOW_TOAST({
                    message: error.response.data.non_field_errors[0],
                    styleType: "danger"
                  })
                }.bind(this)
              );
            } else if (booking_status === BookingStatusEnum.CANCELLED) {
              $("#modal-cancel-apartment-booking").modal("show");
            } else {
              if (utils.isNull(booking_status)) {
                this.data_booking.booking_status = this.apartment_bookings.booking_status
              }
              const data = {
                id: this.booking_id,
                data: this.data_booking
              }
              this.UPDATE_APARTMENT_GROUP_BOOKINGS(data).then(
                function (res) {
                  this.waitingLoading(false)
                  this.ON_SHOW_TOAST({
                    message: this.$t('customer.booking_successfully'),
                    styleType: "success"
                  });
                  // this.callBackToList()
                }.bind(this)
              ).catch(
                function (error) {
                  this.waitingLoading(false)
                  this.ON_SHOW_TOAST({
                    message: error.response.data.non_field_errors[0],
                    styleType: "danger"
                  })
                }.bind(this)
              );
            }
          } else if (result != 'OK'){
              this.waitingLoading(false)
              this.ON_SHOW_TOAST({
                message: result,
                styleType: "danger"
              })
          } else {
              this.waitingLoading(false)
              this.ON_SHOW_TOAST({
                message: "Vui lòng liên hệ quản trị để biết thêm thông tin",
                styleType: "danger"
              })
          }
        },
        callBackToList: function(){
          this.$router.push({
            name: "LeaseBackAvailableApartmentList",
            query: {
              checkin_datetime: this.$route.query.checkin_datetime,
              checkout_datetime: this.$route.query.checkout_datetime
            }
          });
        },
        CancelCustomerList: function () {
          this.callBackToList()
        },
        onSaveApartmentLeasebackClients: function() {
          // Check-in date time with hour
          let checkin_datetime_with_hour = !utils.isNull(this.apartment_leaseback_clients.checkin_datetime) ? moment(this.apartment_leaseback_clients.checkin_datetime, 'DD/MM/YYYY HH:mm').set({hour: this.hour_default_checkin, minutes: this.minute_default_checkin}).format('YYYY-MM-DD HH:mm') : null
          // Check-out date time with hour
          let checkout_datetime_with_hour = !utils.isNull(this.apartment_leaseback_clients.checkout_datetime) ? moment(this.apartment_leaseback_clients.checkout_datetime, 'DD/MM/YYYY HH:mm').set({hour: this.hour_default_checkout, minutes: this.minute_default_checkout}).format('YYYY-MM-DD HH:mm') : null
          // Check-in date time
          let checkin_datetime = utils.formatSqlDate(this.apartment_leaseback_clients.checkin_datetime, 'DD/MM/YYYY HH:mm', 'YYYY-MM-DD HH:mm')
          // Check-out date time
          let checkout_datetime = utils.formatSqlDate(this.apartment_leaseback_clients.checkout_datetime, 'DD/MM/YYYY HH:mm', 'YYYY-MM-DD HH:mm')
          // Check-in date time expected
          let checkin_datetime_expected = !utils.isNull(this.apartment_bookings.checkin_datetime) ? moment(this.apartment_bookings.checkin_datetime, 'DD/MM/YYYY').set({hour: this.hour_default_checkin, minutes: this.minute_default_checkin}).format('YYYY-MM-DD HH:mm') : null
          // Check-out date time expected
          let checkout_datetime_expected = !utils.isNull(this.apartment_bookings.checkout_datetime) ? moment(this.apartment_bookings.checkout_datetime, 'DD/MM/YYYY').set({hour: this.hour_default_checkout, minutes: this.minute_default_checkout}).format('YYYY-MM-DD HH:mm') : null
          if (utils.isNull(this.apartment_leaseback_clients.full_name) || (!utils.isNull(this.apartment_leaseback_clients.full_name) && this.apartment_leaseback_clients.full_name == "")) {
            this.ON_SHOW_TOAST({
              message: "Vui lòng nhập họ và tên",
              styleType: "danger"
            })
          } else if (!utils.isNull(this.apartment_leaseback_clients.checkin_datetime) || !utils.isNull(this.apartment_leaseback_clients.checkout_datetime) && checkin_datetime < checkin_datetime_expected) {
            this.ON_SHOW_TOAST({
              message: this.$t('apartmentbookings.apartment_leaseback_clients.checkin_less_checkin_expected'),
              styleType: "danger"
            })
          } else if (!utils.isNull(this.apartment_leaseback_clients.checkin_datetime) || !utils.isNull(this.apartment_leaseback_clients.checkout_datetime) && checkin_datetime > checkout_datetime_expected) {
            this.ON_SHOW_TOAST({
              message: this.$t('apartmentbookings.apartment_leaseback_clients.checkin_greater_checkin_expected'),
              styleType: "danger"
            })
          } else if (!utils.isNull(this.apartment_leaseback_clients.checkin_datetime) || !utils.isNull(this.apartment_leaseback_clients.checkout_datetime) && checkout_datetime < checkin_datetime_expected) {
            this.ON_SHOW_TOAST({
              message: this.$t('apartmentbookings.apartment_leaseback_clients.checkout_less_checkin_expected'),
              styleType: "danger"
            })
          } else if (!utils.isNull(this.apartment_leaseback_clients.checkin_datetime) || !utils.isNull(this.apartment_leaseback_clients.checkout_datetime) && checkout_datetime > checkout_datetime_expected) {
            this.ON_SHOW_TOAST({
              message: this.$t('apartmentbookings.apartment_leaseback_clients.checkout_greater_checkout_expected'),
              styleType: "danger"
            })
          } else if (!utils.isNull(this.apartment_leaseback_clients.checkin_datetime) || !utils.isNull(this.apartment_leaseback_clients.checkout_datetime) && checkin_datetime_with_hour > checkout_datetime_with_hour) {
            this.ON_SHOW_TOAST({
              message: this.$t('apartmentbookings.apartment_leaseback_clients.invalid_checkin'),
              styleType: "danger"
            })
          } else {
            let data = {
              id:this.apartment_leaseback_clients.id,
              full_name: this.apartment_leaseback_clients.full_name,
              first_name: "",
              last_name: "",
              email: this.apartment_leaseback_clients.email,
              dob: utils.formatSqlDate(this.apartment_leaseback_clients.dob, "DD-MM-YYYY", "YYYY-MM-DDThh:mm"),
              phone: this.apartment_leaseback_clients.phone,
              gender: this.apartment_leaseback_clients.gender,
              address: this.apartment_leaseback_clients.address,
              other_details: this.apartment_leaseback_clients.other_details,
              id_passsport: this.apartment_leaseback_clients.id_passsport,
              id_passsport_issued_date: utils.formatSqlDate(this.apartment_leaseback_clients.id_passsport_issued_date, "DD-MM-YYYY", "YYYY-MM-DDThh:mm"),
              visa_number: this.apartment_leaseback_clients.visa_number,
              visa_expired_date: new Date(utils.formatSqlDate(this.apartment_leaseback_clients.visa_expired_date, "DD-MM-YYYY", "YYYY-MM-DD")),
              vn_tmp_stay_start: new Date(utils.formatSqlDate(this.apartment_leaseback_clients.vn_tmp_stay_start, "DD-MM-YYYY", "YYYY-MM-DD")),
              vn_tmp_stay_end: new Date(utils.formatSqlDate(this.apartment_leaseback_clients.vn_tmp_stay_end, "DD-MM-YYYY", "YYYY-MM-DD")),
              represent: this.apartment_leaseback_clients.represent,
              country: this.apartment_leaseback_clients.country_code,
               // Checkin
              checkin_datetime: !utils.isNull(this.apartment_leaseback_clients.checkin_datetime) ? new Date(moment(this.apartment_leaseback_clients.checkin_datetime, "DD-MM-YYYY HH:mm").format("YYYY-MM-DDTHH:mm")) : new Date(moment(checkin_datetime_expected).format("YYYY-MM-DDTHH:mm")),
              // Checkout
              checkout_datetime: !utils.isNull(this.apartment_leaseback_clients.checkout_datetime) ? new Date(moment(this.apartment_leaseback_clients.checkout_datetime, "DD-MM-YYYY HH:mm").format("YYYY-MM-DDTHH:mm")) : new Date(moment(checkout_datetime_expected).format("YYYY-MM-DDTHH:mm")),
              flight: this.apartment_leaseback_clients.flight
            };
            if(this.apartment_leaseback_clients.id == 0){
              this.ADD_APARTMENT_LEASEBACK_CLIENTS(data)
              .then(
                  function (res) {
                      this.waitingLoading(false)
                      this.ON_SHOW_TOAST({
                          message: this.$t("apartmentbookings.apartment_leaseback_clients.created"),
                          styleType: "success"
                      });
                      // update ID
                      data.id = res.id
                      this.list_apartment_lease_back_clients_selected.push(data)
                      if (this.list_apartment_lease_back_clients_selected.length == 1) {
                        data['selected'] = true
                        this.list_apartment_lease_back_clients_selected[0]['selected'] = true
                      }
                      this.resetDataApartmentLeasebackClients()
                  }.bind(this)
              )
              .catch(
                  function (error) {
                      let error_message = error.response.data.message
                      if('other_details' in error.response.data){
                        this.ON_SHOW_TOAST({
                          message: this.$t('apartmentbookings.apartment_leaseback_clients.error.apartment_leaseback_clients_note'),
                          styleType: "danger"
                        })
                      } else if(error_message.includes('duplicate_identificationnumber_passport')){ 
                        this.ON_SHOW_TOAST({
                                  message: this.$t('apartmentbookings.apartment_leaseback_clients.duplicate_identificationnumber_passport'),
                                  styleType: "danger"
                              })
                      } else {
                        {
                          this.ON_SHOW_TOAST({
                                message: error_message,
                                styleType: "danger"
                            })
                          }
                      }
                  }.bind(this)
              )
            } else {
              this.UPDATE_APARTMENT_LEASEBACK_CLIENTS({id: data.id, ...data})
              .then(
                  function (res) {
                      this.waitingLoading(false)
                      this.ON_SHOW_TOAST({
                          message: this.$t("apartmentbookings.apartment_leaseback_clients.edited"),
                          styleType: "success"
                      });
                      this.resetDataApartmentLeasebackClients()
                  }.bind(this)
              )
              .catch(
                  function (error) {
                      let error_message = error.response.data.message
                      if(error_message.includes('other_details')){
                        
                        this.ON_SHOW_TOAST({
                          message: this.$t('apartmentbookings.apartment_leaseback_clients.error.apartment_leaseback_clients_note'),
                          styleType: "danger"
                        })
                      } else if(error_message.includes('duplicate_identificationnumber_passport')){
                        this.ON_SHOW_TOAST({
                                  message: this.$t('apartmentbookings.apartment_leaseback_clients.duplicate_identificationnumber_passport'),
                                  styleType: "danger"
                              })
                      } else {
                        {
                          this.ON_SHOW_TOAST({
                                message: error_message,
                                styleType: "danger"
                            })
                          }
                      }
                  }.bind(this)
              )
            }
          }
        },
        onConfirmDelete: function(){
          $('#modal-apartment-leaseback-client-delete').modal('hide')
          this.list_apartment_lease_back_clients_selected = this.list_apartment_lease_back_clients_selected.filter(item => item.id != this.on_deleted_apartment_lease_back_client.id)
          let main_contact = false
          if (this.list_apartment_lease_back_clients_selected.length == 1) {
            this.list_apartment_lease_back_clients_selected[0]['selected'] = true
          } else {
            for (let i = 0, size = this.list_apartment_lease_back_clients_selected.length; i < size; i++) {
              if (this.list_apartment_lease_back_clients_selected[i]['selected']) {
                main_contact = true
              }
            }
            if (!main_contact) {
              this.list_apartment_lease_back_clients_selected[0]['selected'] = true
            }
          }
        },
        resetDataApartmentLeasebackClients(){
          let data = {
            id : 0,
            id_passsport: null,
            id_passsport_issued_date: null,
            dob: null,
            full_name: null,
            address: null,
            email: null,
            phone: null,
            gender: null,
            country_code: null,
            other_details: null,
            checkin_datetime: null,
            checkout_datetime: null
          }
          this.apartment_leaseback_clients = data
        },
        onResetApartmentLeasebackClients(){
          this.resetDataApartmentLeasebackClients()
        },
        showModalAddCompany: function() {
            this.$refs.modalApartmentLeaseBackCompany.showModalAddCompany(null);
        },
        clickEventOpenModalLeasebackClients(){
          // get all user
          const data = {
            params: {
              page: 1
            }
          };
          this.GET_APARTMENT_LEASEBACK_CLIENTS_LIST(data);
          $("#modal-select-client").modal("show");
        },
        getLeaseBackCompany: function() {
            this.GET_LEASEBACK_COMPANY_LIST().then(
                function(res) {
                    this.leaseback_company_list = []
                    let leaseback_company_list = [];
                    let data = res.data;
                    leaseback_company_list.push({value: null, text: '---'})
                    data.forEach(c => {
                        let leaseback_company = {
                            value: c.id,
                            text: c.name
                        }
                        leaseback_company_list.push(leaseback_company);
                    })
                    this.leaseback_company_list = leaseback_company_list
                }.bind(this)
            )
        },
        reloadLeaseBackCompany: function() {
            this.getLeaseBackCompany();
        },
        doSelectClient(list_apartment_lease_back_clients_selected) {
            list_apartment_lease_back_clients_selected.forEach(v=> {
                v['selected'] = false
                let client_exist = false
                for (let i=0; i < this.list_apartment_lease_back_clients_selected.length; i++){
                    let current_client = this.list_apartment_lease_back_clients_selected[i]
                    if (v.id == current_client.id) {
                        client_exist = true
                        break
                    }
                }
                if (!client_exist) {
                this.list_apartment_lease_back_clients_selected.push(v)
                }
            })
        },
    },
    async mounted() {
        const projectId = utils.getProjectSession()
        this.GET_PROJECT_DETAIL({ id: projectId }).then(
          function(res) {
            let projData = res.data
            this.hour_default_checkin = projData.df_chkin_hour
            this.minute_default_checkin = projData.df_chkin_minute
            this.hour_default_checkout = projData.df_chkout_hour
            this.minute_default_checkout = projData.df_chkout_minute
          }.bind(this)
        )

        this.apartment_bookings.checkin_datetime = this.$route.query.checkin_datetime;
        this.apartment_bookings.checkout_datetime = this.$route.query.checkout_datetime;
        this.getDepositDeadline(this.apartment_bookings.checkin_datetime, null)
        this.getLeaseBackCompany();
        const filter = {
          params: {
            page: 1,
            apt_type: 2,
            apartment_code: '',
            from_size: '',
            to_size: '',
            owner_resident: '',
            status: [],
            checkin_datetime: utils.formatSqlDate(this.apartment_bookings.checkin_datetime, this.options.format, "DD/MM/YYYY"),
            checkout_datetime: utils.formatSqlDate(this.apartment_bookings.checkout_datetime, this.options.format, "DD/MM/YYYY"),
            absc: []
          }
      };
      this.isLoadingAvailableApartmentList = true
      this.GET_AVAILABLE_APARTMENT_LIST(filter)
        .then(
          function() {
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            this.gridApartmentDataList = [];
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
      this.GET_COUNTRY_LIST().then(
        function(res) {
          let countries = [];
          let data = res.data;
          data.forEach(c => {
              let country = {
                  value: c.id,
                  text: c.country_name
              }
              countries.push(country);
          })
          this.country_list = countries;
        }.bind(this)
      );
      let booking_id = parseInt(this.$route.params.id);
      this.booking_id = booking_id
      if (this.booking_id === 0 || utils.isNull(this.booking_id) || isNaN(this.booking_id)) {
        this.booking_id = 0
      }
      if (this.booking_id !== 0) {
        this.isLoadingApartmentBookedList = true
        this.GET_GROUP_BOOKING_DETAIL({id: this.booking_id})
      }
    },
    components: {
      "lte-core-alert": LTECoreAlert,
      "date-picker": datePicker,
      loading: Loading,
      "leaseback-select-option-package": LeaseBackSelectOptionPackage,
      "lte-modal-partment-leaseback-company": LTEModalApartmentLeasebackCompany,
      "select-lease-back-clients-modal" : SelectLeaseBackClientsModal,
      "lte-modal-invoice-general-invoice-detail": LTEModalInvoiceGeneralInvoiceDetail,
    }
};
</script>

<style lang="scss" scoped>
.right-element-container {
    border:2px solid #cecece;
    margin-top:10px;
    margin-bottom:10px;
    margin-right:10px;
    background:white;
}
.dataTable thead .sorting:after,
.dataTable thead .sorting:before,
.dataTable thead .sorting_asc:after,
.dataTable thead .sorting_asc:before,
.dataTable thead .sorting_asc_disabled:after,
.dataTable thead .sorting_asc_disabled:before,
.dataTable thead .sorting_desc:after,
.dataTable thead .sorting_desc:before,
.dataTable thead .sorting_desc_disabled:after,
.dataTable thead .sorting_desc_disabled:before {
bottom: .5em;
}
#dtHorizontal th, td {
  white-space: nowrap;  
  padding: 10px 15px 10px 15px;
}
#apartmentInformation td {
  white-space: normal;
  padding: 0;
}
table {
  display: block;
  overflow-x: auto;
}
.bg-select {
  background-color: green;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/LeaseBackApartmentBookingForGroup.vue